export const data = [
  {
    "Title": "Adam Legend of the Blue Marvel",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Adventures of Kool-Aid Man",
    "Issue #": "",
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Alpha Flight",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Alpha Flight",
    "Issue #": 51,
    "Condition": "NM",
    "Website Notes": "1st Lee",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adult Fantasy",
    "Issue #": 7,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 170,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adult Fantasy",
    "Issue #": 11,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Amazing Adult Fantasy",
    "Issue #": 11,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "Derrylle",
    "__1": ""
  },
  {
    "Title": "Amazing Adult Fantasy",
    "Issue #": 11,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Amazing Adult Fantasy",
    "Issue #": 12,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 430,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adult Fantasy",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent referal",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1961)",
    "Issue #": 1,
    "Condition": "F/G",
    "Website Notes": "Dr Droom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referal",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1961)",
    "Issue #": 4,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referal",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1961)",
    "Issue #": 5,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referal",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1961)",
    "Issue #": 6,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referal",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "1st Furry Beast",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "1st Furry Beast",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 32,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 13,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 16,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures(1970)",
    "Issue #": 16,
    "Condition": "VG/F",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Adventures (1979)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Fantasy",
    "Issue #": 15,
    "Condition": "CGC 2.0",
    "Website Notes": "1st Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18000,
    "": "Cutler",
    "__1": ""
  },
  {
    "Title": "Amazing Fantasy",
    "Issue #": 15,
    "Condition": "CGC 1.5",
    "Website Notes": "1st Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15000,
    "": "Ohio",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 1,
    "Condition": "CGC 4.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8500,
    "": "Jess",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 1,
    "Condition": "CGC 2.5",
    "Website Notes": "Stan Lee Signature",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 9800,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 1,
    "Condition": "CGC 2.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5000,
    "": "Shu",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 1,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5000,
    "": "Weiner",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 2,
    "Condition": "CGC 3.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "Ben",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "1st Doc Ock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 3,
    "Condition": "CGC 4.5",
    "Website Notes": "1st Doc Ock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 4,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1650,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 5,
    "Condition": "VG-",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 5,
    "Condition": "GD-",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Weiner",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 6,
    "Condition": "FR",
    "Website Notes": "Centerfold Missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 7,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 725,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 7,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 275,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 7,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 7,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 8,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 8,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 9,
    "Condition": "CGC 5.0",
    "Website Notes": "Stan Lee Signature on case",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 765,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 10,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 425,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 11,
    "Condition": "GD",
    "Website Notes": "Tape on Spine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 11,
    "Condition": "GD-",
    "Website Notes": "Doc Ock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Roanoke",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 12,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 12,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 225,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "Doc Ock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Roanoke",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 13,
    "Condition": "CGC 5.0",
    "Website Notes": "1st Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 890,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 13,
    "Condition": "CGC 4.5",
    "Website Notes": "1st Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "Vollbach",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 13,
    "Condition": "VG+",
    "Website Notes": "1st Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 880,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 13,
    "Condition": "VG",
    "Website Notes": "1st Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 190,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 13,
    "Condition": "VG-",
    "Website Notes": "1st Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "1st Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 14,
    "Condition": "CGC 5.0",
    "Website Notes": "1st Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1825,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 14,
    "Condition": "CGC 4.0",
    "Website Notes": "1st Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1120,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 14,
    "Condition": "G/VG",
    "Website Notes": "1st Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 550,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 15,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1865,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 15,
    "Condition": "CGC 4.5",
    "Website Notes": "1st Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 720,
    "": "CConnect",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 15,
    "Condition": "CGC 3.5",
    "Website Notes": "1st Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1352,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 15,
    "Condition": "CGC 3.0",
    "Website Notes": "1st Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 850,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 15,
    "Condition": "GD+",
    "Website Notes": "1st Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 15,
    "Condition": "GD-",
    "Website Notes": "1st Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 16,
    "Condition": "CGC 7.0",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 723,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 16,
    "Condition": "G/VG",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 16,
    "Condition": "GD",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 200,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 16,
    "Condition": "GD-",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 17,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 17,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 17,
    "Condition": "G/G-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 18,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 345,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 18,
    "Condition": "CGC 6.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "CConnect",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 18,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 19,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 155,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 20,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 750,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "1st Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 360,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "1st Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "1st Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 21,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 22,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 21,
    "Condition": "F/G",
    "Website Notes": "2nd Beetle",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 23,
    "Condition": "FA",
    "Website Notes": "non story page out",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 45,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 24,
    "Condition": "FA",
    "Website Notes": "non story page out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 25,
    "Condition": "CBCS 7.5",
    "Website Notes": "1st MJ",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 375,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "1st MJ",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 25,
    "Condition": "VG",
    "Website Notes": "1st MJ",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 25,
    "Condition": "FA",
    "Website Notes": "non story page out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 26,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 26,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 26,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 26,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Roanoke",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 27,
    "Condition": "CGC 7.0",
    "Website Notes": "4th Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 237,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 27,
    "Condition": "VG/F",
    "Website Notes": "4th Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Shawn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 28,
    "Condition": "VG",
    "Website Notes": "Molten Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 29,
    "Condition": "CGC 7.0",
    "Website Notes": "Savannah",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 29,
    "Condition": "CGC 6.5",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 195,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 29,
    "Condition": "VG/F",
    "Website Notes": "2nd Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 29,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 30,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 30,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 30,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 31,
    "Condition": "FN",
    "Website Notes": "1st Gwen Stacy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 31,
    "Condition": "VG/F",
    "Website Notes": "1st Gwen Stacy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 32,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 32,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 33,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 160,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 34,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 34,
    "Condition": "GD",
    "Website Notes": "Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 35,
    "Condition": "CGC 8.5",
    "Website Notes": "2nd Molten Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "2nd Molten Man",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 65,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 35,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 36,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 37,
    "Condition": "VG/F",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 115,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 37,
    "Condition": "CGC 5.0",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 139,
    "": "Pedigree",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 37,
    "Condition": "VG",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 39,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "old stock",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 39,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 40,
    "Condition": "VG",
    "Website Notes": "Origin G Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 41,
    "Condition": "VG+",
    "Website Notes": "1st Rhino",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 41,
    "Condition": "GD+",
    "Website Notes": "1st Rhino",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 42,
    "Condition": "FN",
    "Website Notes": "MJ Face shown",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "MJ Face shown",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 42,
    "Condition": "VG+",
    "Website Notes": "MJ Face shown",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 43,
    "Condition": "F/VF",
    "Website Notes": "Origin Rhino",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 43,
    "Condition": "FN+",
    "Website Notes": "Origin Rhino",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Nick GE",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 43,
    "Condition": "VG",
    "Website Notes": "Origin Rhino",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 44,
    "Condition": "FN-",
    "Website Notes": "Lizard",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 45,
    "Condition": "F/VF",
    "Website Notes": "Lizard",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 47,
    "Condition": "CGC 9.2",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 47,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Florida",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 47,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 47,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 48,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 49,
    "Condition": "GD",
    "Website Notes": "Vulture",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 50,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Kingpin",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 600,
    "": 900,
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 50,
    "Condition": "CGC 5.0",
    "Website Notes": "1st Kingpin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 50,
    "Condition": "CGC 4.0",
    "Website Notes": "1st Kingpin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 570,
    "": "CConnect",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 50,
    "Condition": "GD",
    "Website Notes": "1st Kingpin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 51,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Kingpin Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 51,
    "Condition": "VF-",
    "Website Notes": "1st Kingpin Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 51,
    "Condition": "F/VF",
    "Website Notes": "1st Kingpin Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Nick GE",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 51,
    "Condition": "VG+",
    "Website Notes": "1st Kingpin Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Annandale",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 51,
    "Condition": "VG",
    "Website Notes": "1st Kingpin Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 52,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "SDCC",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 53,
    "Condition": "VG",
    "Website Notes": "Doc Ock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 54,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "SDCC",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 54,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 55,
    "Condition": "VG/F",
    "Website Notes": "Classic Doc Ock Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 55,
    "Condition": "VG",
    "Website Notes": "Classic Doc Ock Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 55,
    "Condition": "VG-",
    "Website Notes": "Classic Doc Ock Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 56,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 56,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 56,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Annandale",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 56,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 57,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 57,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 57,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 57,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 58,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "SDCC",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 58,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 58,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 58,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 58,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 59,
    "Condition": "VF-",
    "Website Notes": "1st MJ cover",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 59,
    "Condition": "FN+",
    "Website Notes": "1st MJ cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 59,
    "Condition": "VG/F",
    "Website Notes": "1st MJ cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 60,
    "Condition": "VG/F",
    "Website Notes": "Kingpin",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "Annandale",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 60,
    "Condition": "G/VG",
    "Website Notes": "Kingpin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "Gwen Stacy Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 61,
    "Condition": "VG",
    "Website Notes": "Gwen Stacy Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 62,
    "Condition": "VF",
    "Website Notes": "Medusa",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 63,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 63,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 64,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "SDCC",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 64,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 64,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 65,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Nick GE",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 65,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 65,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 65,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 66,
    "Condition": "VG",
    "Website Notes": "Mysterio",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 67,
    "Condition": "VF+",
    "Website Notes": "Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "SDCC",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 67,
    "Condition": "VF",
    "Website Notes": "Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 67,
    "Condition": "FN",
    "Website Notes": "Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 67,
    "Condition": "VG/F",
    "Website Notes": "Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "giligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 68,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "giligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 69,
    "Condition": "VG+",
    "Website Notes": "Kingpin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "giligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 70,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 26,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 70,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 71,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 71,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 72,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 48,
    "": "Columbus",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 72,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 73,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 74,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 46,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 74,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 74,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 77,
    "Condition": "F/VF",
    "Website Notes": "Lizard",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 78,
    "Condition": "VG",
    "Website Notes": "1st Prowler",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 79,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 79,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 79,
    "Condition": "VG/F",
    "Website Notes": "Prowler",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 81,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 82,
    "Condition": "VG",
    "Website Notes": "Electro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 83,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Shawn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 85,
    "Condition": "VG+",
    "Website Notes": "Kingpin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Nick GE",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 88,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 88,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 88,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 89,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 90,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Roanoke",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 90,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 90,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 91,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 91,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 92,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 92,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 93,
    "Condition": "FN-",
    "Website Notes": "Prowler",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 93,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 93,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 94,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 94,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 94,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 95,
    "Condition": "FN+",
    "Website Notes": "London",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 96,
    "Condition": "FN+",
    "Website Notes": "Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 96,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 96,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 97,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 97,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 97,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 98,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "inked",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 99,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "eric",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 99,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 99,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 99,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 100,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 320,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 100,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 101,
    "Condition": "VG/F",
    "Website Notes": "1st Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 170,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 101,
    "Condition": "VG",
    "Website Notes": "1st Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 101,
    "Condition": "NM",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 102,
    "Condition": "VF",
    "Website Notes": "Inked on top",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Flrida",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 102,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 103,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 103,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Fredeick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 104,
    "Condition": "VF-",
    "Website Notes": "Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 104,
    "Condition": "FN",
    "Website Notes": "Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 105,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 106,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 107,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dmitri",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 108,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 109,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 109,
    "Condition": "VF-",
    "Website Notes": "Dr Strange",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 109,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Aftertime",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 111,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 111,
    "Condition": "VF+",
    "Website Notes": "Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 112,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 112,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 113,
    "Condition": "VG/F",
    "Website Notes": "1st Hammerhead",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 115,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 115,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 116,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 117,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 117,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 117,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 118,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 119,
    "Condition": "VF+",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 119,
    "Condition": "FN",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 119,
    "Condition": "GD",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 120,
    "Condition": "VF",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 120,
    "Condition": "F/VF",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 120,
    "Condition": "FN+",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 120,
    "Condition": "FN-",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 121,
    "Condition": "CGC 9.4",
    "Website Notes": "Death of Gwen Stacy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 121,
    "Condition": "CGC 4.5",
    "Website Notes": "Death of Gwen Stacy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 203,
    "": "Pedigree",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 121,
    "Condition": "CGC 4.0",
    "Website Notes": "Death of Gwen Stacy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 265,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 121,
    "Condition": "VG-",
    "Website Notes": "Death of Gwen Stacy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 122,
    "Condition": "CGC 9.0",
    "Website Notes": "Death of G Goblin",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 425,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 122,
    "Condition": "CGC 8.5",
    "Website Notes": "Death of G Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 380,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 122,
    "Condition": "CBCS 8.5",
    "Website Notes": "Death of G Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 410,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 122,
    "Condition": "VF",
    "Website Notes": "Death of G Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 122,
    "Condition": "CGC 7.0",
    "Website Notes": "Death of G Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 245,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 122,
    "Condition": "FN",
    "Website Notes": "Death of G Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 122,
    "Condition": "VG-",
    "Website Notes": "Death of G Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 123,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 155,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 123,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 123,
    "Condition": "FN-",
    "Website Notes": "Luke Cage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 124,
    "Condition": "VF",
    "Website Notes": "1st Man Wolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Owen",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 124,
    "Condition": "F/VF",
    "Website Notes": "1st Man Wolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 124,
    "Condition": "VG/F",
    "Website Notes": "1st Man Wolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 125,
    "Condition": "VF-",
    "Website Notes": "2nd Man Wolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 125,
    "Condition": "FN",
    "Website Notes": "2nd Man Wolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 126,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 126,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 126,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 127,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 127,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 127,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 128,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 128,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 28,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 128,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "CBCS 9.0",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 3000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "CGC 7.0",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "CGC 5.0",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1515,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "CGC 4.5",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1325,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "VG-",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 320,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "G/VG",
    "Website Notes": "1st Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 650,
    "": "BCC Trade/Cash",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 129,
    "Condition": "VF",
    "Website Notes": "Marvel Milestone Edition",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 130,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "H Valley",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 130,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 130,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 131,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 131,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 131,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 132,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 132,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Gary",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 133,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 134,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 134,
    "Condition": "VG/F",
    "Website Notes": "1st Tarantula",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 135,
    "Condition": "CGC 9.2",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 135,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 135,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Owen",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 135,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 136,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 136,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 136,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 425,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 137,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 178,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 137,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 138,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 138,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 140,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 141,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 28,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 142,
    "Condition": "VG",
    "Website Notes": "Mysterio",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 143,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 143,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 144,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 144,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 145,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 146,
    "Condition": "NM-",
    "Website Notes": "Western Penn",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 146,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 28,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 146,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 147,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 28,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 147,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 147,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 148,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 148,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 149,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Clone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 149,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 27,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 149,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 150,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 150,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 151,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 151,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 152,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 153,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 154,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 154,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 154,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 154,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 155,
    "Condition": "FN",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 155,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 155,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 156,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 156,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 156,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 156,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 156,
    "Condition": "CGC 9.0",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 157,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 157,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 21,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 157,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 158,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 158,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 158,
    "Condition": "CGC 8.5",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 158,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 158,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 159,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 160,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 160,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 161,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 161,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 162,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 162,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 162,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 162,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Cliff Trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 163,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 163,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 164,
    "Condition": "NM-",
    "Website Notes": "Kingpin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 164,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 164,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 165,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 165,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 165,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 165,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 166,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 166,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 167,
    "Condition": "NM+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 167,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 168,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 168,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 168,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 169,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 169,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 170,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 170,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 170,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 171,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 171,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 172,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 172,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 172,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 173,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 173,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 173,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 174,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 174,
    "Condition": "F/VF",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 175,
    "Condition": "VF",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 175,
    "Condition": "F/VF",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 176,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 177,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 177,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 178,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 179,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 180,
    "Condition": "NM+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 181,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 181,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 181,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 182,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 182,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 182,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 183,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 183,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 184,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 184,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 184,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 185,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 185,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 186,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 186,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 186,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 187,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 188,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 188,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 189,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 189,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 190,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 191,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 191,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 193,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 193,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 193,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 194,
    "Condition": "FN",
    "Website Notes": "1st Black Cat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 194,
    "Condition": "CGC 9.6",
    "Website Notes": "1st Black Cat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 650,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 194,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Black Cat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "Shu",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 195,
    "Condition": "NM",
    "Website Notes": "Origin Black Cat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 195,
    "Condition": "F/VF",
    "Website Notes": "Origin Black Cat",
    "Personal Notes (Not on website)": "Newsstand",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 196,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 196,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 196,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 197,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 198,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 199,
    "Condition": "NM",
    "Website Notes": "Western Penn Copy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 199,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 200,
    "Condition": "NM+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 200,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Bednarz",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 200,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 201,
    "Condition": "NM-",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 202,
    "Condition": "NM-",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 202,
    "Condition": "VG/F",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 204,
    "Condition": "NM",
    "Website Notes": "Black Cat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 205,
    "Condition": "FN",
    "Website Notes": "Black Cat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 206,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 209,
    "Condition": "VF",
    "Website Notes": "1st Calypso",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 210,
    "Condition": "CGC 9.6",
    "Website Notes": "1st Madame Web",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 210,
    "Condition": "VF/NM",
    "Website Notes": "1st Madam Web",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 210,
    "Condition": "VG/F",
    "Website Notes": "1st Madam Web",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Annandale",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 211,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 212,
    "Condition": "VF",
    "Website Notes": "1st Hydro Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 215,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 216,
    "Condition": "NM",
    "Website Notes": "2nd Madame Web",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 216,
    "Condition": "VF/NM",
    "Website Notes": "2nd Madame Web",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 217,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 217,
    "Condition": "VG/F",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 218,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 219,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 219,
    "Condition": "FN+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 220,
    "Condition": "NM",
    "Website Notes": "Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 221,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 223,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 223,
    "Condition": "FN",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 225,
    "Condition": "FN",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 226,
    "Condition": "CGC9.8",
    "Website Notes": "Black Cat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 190,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 230,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 230,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 231,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 232,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 232,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 233,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 233,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 238,
    "Condition": "VG/F",
    "Website Notes": "No Tattooz",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 239,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 239,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 239,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 240,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 243,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 244,
    "Condition": "NM",
    "Website Notes": "Hobgoblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 245,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 246,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 246,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 247,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 248,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 249,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 249,
    "Condition": "F/VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 250,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 251,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 252,
    "Condition": "NM-",
    "Website Notes": "1st Black Costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 252,
    "Condition": "VF/NM",
    "Website Notes": "1st Black Costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 252,
    "Condition": "VF",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 253,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 253,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 254,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 255,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 257,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 259,
    "Condition": "NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 259,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 260,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 260,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 261,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 262,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 262,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 263,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 263,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 264,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 265,
    "Condition": "VF/NM",
    "Website Notes": "1st Silver Sable",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 268,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 269,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 275,
    "Condition": "NM-",
    "Website Notes": "Frenz Auto 1st page",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 277,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 278,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 279,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 281,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 282,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 282,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 283,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 284,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 285,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 286,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 289,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 60,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 289,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 290,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 291,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 292,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 293,
    "Condition": "CGC 9.8",
    "Website Notes": "Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 298,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 299,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 525,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 299,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "NM-",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 600,
    "": "gvalley",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 850,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "CGC 9.4",
    "Website Notes": "SS McFarlane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "CGC 9.4",
    "Website Notes": "SS McFarlane NEWSSTAND",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "Frederick Trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 300,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "Shu",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 301,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 302,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 303,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 303,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 304,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 305,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 308,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 309,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 309,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 312,
    "Condition": "NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 312,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 313,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 30,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 314,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 314,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 315,
    "Condition": "NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 315,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 316,
    "Condition": "NM-",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 316,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 316,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 316,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 317,
    "Condition": "NM-",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 317,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 317,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 324,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 324,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 325,
    "Condition": "VF/NM",
    "Website Notes": "McFarlane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 328,
    "Condition": "NM",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 328,
    "Condition": "VF",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 330,
    "Condition": "NM",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 333,
    "Condition": "NM-",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 334,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 344,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 344,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "TTReasures",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 347,
    "Condition": "VF/NM",
    "Website Notes": "Venom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 347,
    "Condition": "F/VF",
    "Website Notes": "Venom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 349,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 350,
    "Condition": "NM-",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 351,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 353,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 354,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 355,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 358,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 359,
    "Condition": "NM",
    "Website Notes": "Cameo Carnage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 360,
    "Condition": "NM",
    "Website Notes": "Cameo Carnage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 360,
    "Condition": "F/VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 361,
    "Condition": "CGC 9.8",
    "Website Notes": "1st Carnage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 361,
    "Condition": "CGC 9.8",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 361,
    "Condition": "NM",
    "Website Notes": "1st Carnage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 361,
    "Condition": "NM-",
    "Website Notes": "1st Carnage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 361,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 361,
    "Condition": "VF+",
    "Website Notes": "1st Carnage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Green Valley",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 361,
    "Condition": "VF",
    "Website Notes": "1st Carnage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 362,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 363,
    "Condition": "NM",
    "Website Notes": "Carnage",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 363,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 365,
    "Condition": "VF/NM",
    "Website Notes": "1st Spider-Man 2099",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Nick GE",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 368,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 371,
    "Condition": "FN",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 372,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 374,
    "Condition": "VF/NM",
    "Website Notes": "Venom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 375,
    "Condition": "NM",
    "Website Notes": "Anniversary Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 375,
    "Condition": "NM-",
    "Website Notes": "Anniversary Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 379,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 383,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 384,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 385,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 386,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 387,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 388,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 388,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 393,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 399,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 400,
    "Condition": "NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 400,
    "Condition": "VF/NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 401,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 430,
    "Condition": "VF/NM",
    "Website Notes": "Carnage Cosmic",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 431,
    "Condition": "NM-",
    "Website Notes": "Carnage Cosmic",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 569,
    "Condition": "CGC 9.8",
    "Website Notes": "2nd Print Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 725,
    "": "CConnect",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 569,
    "Condition": "NM-",
    "Website Notes": "1st Anti-Venom Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 570,
    "Condition": "NM",
    "Website Notes": "2nd Print Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Green Valley",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 606,
    "Condition": "VF/NM",
    "Website Notes": "Campbell Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 606,
    "Condition": "VF",
    "Website Notes": "Campbell Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 700,
    "Condition": "CGC 9.8",
    "Website Notes": "Stan Lee SS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 245,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 700,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 1,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 1,
    "Condition": "CGC 1.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 1,
    "Condition": "P/F",
    "Website Notes": "No back cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 1,
    "Condition": "P",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "Human Torch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 4,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 7,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 9,
    "Condition": "NM-",
    "Website Notes": "Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 9,
    "Condition": "VF-",
    "Website Notes": "Green Goblin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "palm springs",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 13,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 14,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 15,
    "Condition": "NM-",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Jerry Friend",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 16,
    "Condition": "VF/NM",
    "Website Notes": "Romita/Romita Jr Signature",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 16,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Shu",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 16,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 21,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Jerry Friend",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 26,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Annual",
    "Issue #": 26,
    "Condition": "VF/NM",
    "Website Notes": "Venom Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man Skating on Thin Ice",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Aim Toothepaste Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man",
    "Issue #": "nn",
    "Condition": "NM-",
    "Website Notes": "All Detergent Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Amazing Spider-Man (2018)",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Campbell Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 7,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 12,
    "Condition": "FN+",
    "Website Notes": "Man Thing Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 12,
    "Condition": "FN",
    "Website Notes": "Man Thing Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "Man Thing Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "Man Thing Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 22,
    "Condition": "VF/NM",
    "Website Notes": "IT!",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 25,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 25,
    "Condition": "F/VF",
    "Website Notes": "1st Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "1st Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 26,
    "Condition": "FN+",
    "Website Notes": "2nd Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 30,
    "Condition": "NM",
    "Website Notes": "Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 34,
    "Condition": "NM",
    "Website Notes": "Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 35,
    "Condition": "NM-",
    "Website Notes": "Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Astonishing Tales",
    "Issue #": 36,
    "Condition": "NM-",
    "Website Notes": "Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "A-Team",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "A-Team",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 1,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 11500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 1,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 1,
    "Condition": "CGC 3.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 1,
    "Condition": "CGC 4.0",
    "Website Notes": "Stan Lee SS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 1,
    "Condition": "CGC 1.0",
    "Website Notes": "Slt R C-2",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "Kent Ref",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 1,
    "Condition": "P",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 5,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "1st Baron Zemo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "Classic Thor Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 7,
    "Condition": "CGC 3.5",
    "Website Notes": "Classic Thor Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 7,
    "Condition": "VG-",
    "Website Notes": "Classic Thor Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 7,
    "Condition": "G/VG",
    "Website Notes": "Classic Thor Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 8,
    "Condition": "CGC 7.0",
    "Website Notes": "1st Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 750,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "1st Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 8,
    "Condition": "CGC 4.0",
    "Website Notes": "1st Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 8,
    "Condition": "CGC 3.5",
    "Website Notes": "1st Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 8,
    "Condition": "VG-",
    "Website Notes": "1st Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 8,
    "Condition": "G/VG",
    "Website Notes": "1st Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "Dave",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 9,
    "Condition": "FN-",
    "Website Notes": "1st Wonder Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 285,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "1st Wonder Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 10,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 10,
    "Condition": "F/G",
    "Website Notes": "Non story page missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "Spidey C/S",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 185,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "Color Touch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "Spidey C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 11,
    "Condition": "G/VG",
    "Website Notes": "Spidey C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 12,
    "Condition": "CGC 9.0",
    "Website Notes": "Classic Thor Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "Classic Thor Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "Classic Thor Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 13,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 13,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 14,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 15,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 16,
    "Condition": "CGC 7.5",
    "Website Notes": "New Lineup",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 16,
    "Condition": "F/VF",
    "Website Notes": "New Lineup",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 300,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 16,
    "Condition": "FN",
    "Website Notes": "Jack Kirby' on 1st Page",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 95,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 16,
    "Condition": "VG",
    "Website Notes": "New Lineup",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 17,
    "Condition": "FN+",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 18,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 19,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 19,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 17,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 21,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 21,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 22,
    "Condition": "F/VF",
    "Website Notes": "1st Renslayer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 23,
    "Condition": "F/VF",
    "Website Notes": "1st Renslayer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Dave",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 23,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 24,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 24,
    "Condition": "VG/F",
    "Website Notes": "Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 25,
    "Condition": "F/VF",
    "Website Notes": "Dr Doom c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 25,
    "Condition": "FN",
    "Website Notes": "Dr Doom c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom c/s",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 26,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 52,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 26,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 26,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 27,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 27,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 28,
    "Condition": "VF",
    "Website Notes": "1st Collector",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 28,
    "Condition": "FN+",
    "Website Notes": "1st Collector",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 28,
    "Condition": "VG/F",
    "Website Notes": "1st Collector",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 28,
    "Condition": "VG",
    "Website Notes": "1st Collector",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 29,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 29,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 30,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 30,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 30,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 30,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 31,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 31,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 32,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 33,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 34,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 34,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 35,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 36,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 36,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 36,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 37,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 37,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 37,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 38,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 39,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 40,
    "Condition": "F/VF",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 41,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 41,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 41,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 42,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 43,
    "Condition": "FN-",
    "Website Notes": "1st Red Guardian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 43,
    "Condition": "G/VG",
    "Website Notes": "1st Red Guardian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Gary trade",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 43,
    "Condition": "GD+",
    "Website Notes": "1st Red Guardian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 44,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 45,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 45,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 46,
    "Condition": "VG/F",
    "Website Notes": "Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 46,
    "Condition": "VG",
    "Website Notes": "Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 47,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 47,
    "Condition": "GD",
    "Website Notes": "non story page missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 48,
    "Condition": "CGC 6.5",
    "Website Notes": "1st Black Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Shu",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 48,
    "Condition": "FN",
    "Website Notes": "1st Black Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 48,
    "Condition": "FN-",
    "Website Notes": "1st Black Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 49,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 50,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 50,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 51,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 51,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 51,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 52,
    "Condition": "VG.F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 52,
    "Condition": "VG",
    "Website Notes": "CFL",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 53,
    "Condition": "CGC 9.2",
    "Website Notes": "vs X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 230,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 53,
    "Condition": "NM-",
    "Website Notes": "vs X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 53,
    "Condition": "VF+",
    "Website Notes": "vs X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 53,
    "Condition": "FN+",
    "Website Notes": "vs X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 53,
    "Condition": "G/VG",
    "Website Notes": "CFL",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 54,
    "Condition": "VF+",
    "Website Notes": "1st Ultron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 54,
    "Condition": "VF",
    "Website Notes": "1st Ultron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 54,
    "Condition": "FN",
    "Website Notes": "1st Ultron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 31,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 54,
    "Condition": "G/VG",
    "Website Notes": "POBC",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 55,
    "Condition": "FN+",
    "Website Notes": "1st Ultron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 55,
    "Condition": "VG/F",
    "Website Notes": "Ultron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 56,
    "Condition": "VG/F",
    "Website Notes": "Origin Cap",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 57,
    "Condition": "HALO 8.5",
    "Website Notes": "1st Vision",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 340,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 57,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Vision",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 850,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 57,
    "Condition": "CGC 6.5",
    "Website Notes": "1st Vision",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Ray",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 57,
    "Condition": "G/VG",
    "Website Notes": "1st Vision",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 58,
    "Condition": "VF",
    "Website Notes": "2nd Vision",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 58,
    "Condition": "VF-",
    "Website Notes": "2nd Vision",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 59,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Yellowjacket",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 550,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 59,
    "Condition": "VF",
    "Website Notes": "1st Yellowjacket",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 59,
    "Condition": "F/VF",
    "Website Notes": "1st Yellowjacket",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 61,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 62,
    "Condition": "VG/F",
    "Website Notes": "1st Man Ape",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 64,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 64,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 65,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 67,
    "Condition": "VF",
    "Website Notes": "Smith art",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 32,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 67,
    "Condition": "VG/F",
    "Website Notes": "Smith art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 70,
    "Condition": "FN+",
    "Website Notes": "1st Squadron Sinister",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 73,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 74,
    "Condition": "VF/NM",
    "Website Notes": "Palmer Auto 1st Page",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 75,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 78,
    "Condition": "FN+",
    "Website Notes": "1st Lethal Legion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 78,
    "Condition": "VG/F",
    "Website Notes": "1st Lethal Legion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 80,
    "Condition": "VF",
    "Website Notes": "1st Red Wolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 43,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 81,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 83,
    "Condition": "F/VF",
    "Website Notes": "1st Lady Liberators",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 83,
    "Condition": "VG",
    "Website Notes": "1st Lady Liberators",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 84,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 84,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 85,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 86,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 92,
    "Condition": "F/VF",
    "Website Notes": "Adams Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 93,
    "Condition": "VF-",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 93,
    "Condition": "FN+",
    "Website Notes": "Adams Signature",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 93,
    "Condition": "VG",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 94,
    "Condition": "F/VF",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 94,
    "Condition": "VF",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 94,
    "Condition": "VG",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 95,
    "Condition": "F/VF",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 96,
    "Condition": "F/VF",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 99,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 100,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 102,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 103,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 104,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 106,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 107,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 110,
    "Condition": "CGC 9.6",
    "Website Notes": "Magneto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 155,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 110,
    "Condition": "VF",
    "Website Notes": "Magneto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 112,
    "Condition": "VF",
    "Website Notes": "1st Mantis",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 112,
    "Condition": "VF-",
    "Website Notes": "1st Mantis",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 112,
    "Condition": "FN-",
    "Website Notes": "1st Mantis",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 113,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 113,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 114,
    "Condition": "VF/NM",
    "Website Notes": "Mantis C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 115,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 116,
    "Condition": "VF/NM",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 117,
    "Condition": "FN+",
    "Website Notes": "Defenders",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 119,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 121,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 123,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 125,
    "Condition": "VG/F",
    "Website Notes": "Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 126,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 129,
    "Condition": "F/VF",
    "Website Notes": "Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 130,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 131,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 134,
    "Condition": "VF+",
    "Website Notes": "Origin Vision",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 134,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 134,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 135,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 135,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 135,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 17,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 141,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 142,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 144,
    "Condition": "FN+",
    "Website Notes": "Hellcat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 147,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 148,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 149,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 150,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 151,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 152,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 152,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 153,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 154,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 154,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 155,
    "Condition": "NM",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 156,
    "Condition": "NM",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 156,
    "Condition": "VF",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 157,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 157,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 158,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 158,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 160,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 161,
    "Condition": "VF+",
    "Website Notes": "Classic S Witch Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 161,
    "Condition": "VF",
    "Website Notes": "Classic S Witch Cvr",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 166,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 167,
    "Condition": "F/VF",
    "Website Notes": "GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 168,
    "Condition": "VF+",
    "Website Notes": "GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 171,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 173,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 177,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 179,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 181,
    "Condition": "VF+",
    "Website Notes": "1st Scott Lang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 181,
    "Condition": "VF",
    "Website Notes": "1st Scott Lang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 183,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 184,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 187,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 195,
    "Condition": "VF+",
    "Website Notes": "Taskmaster",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 196,
    "Condition": "VG/F",
    "Website Notes": "1st Taskmaster",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 42,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 200,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 202,
    "Condition": "VF",
    "Website Notes": "Ultron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 204,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 205,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 207,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 211,
    "Condition": "VF",
    "Website Notes": "Tigra Joins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 223,
    "Condition": "VF",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 223,
    "Condition": "NM",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers",
    "Issue #": 227,
    "Condition": "FN+",
    "Website Notes": "Captain Marvel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 8,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 10,
    "Condition": "CGC 9.6",
    "Website Notes": "1st Rogue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "1st Rogue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 10,
    "Condition": "CGC 9.2",
    "Website Notes": "1st Rogue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "1st Rogue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ogden",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "Avengers Annual",
    "Issue #": 11,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Avengers (Vol 2)",
    "Issue #": 36,
    "Condition": "NM",
    "Website Notes": "Hasbro Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Beware",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Goliath",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": ".30 Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "hunt valley",
    "__1": ""
  },
  {
    "Title": "Black Knight",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": 1990,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 115,
    "": "pedigree",
    "__1": ""
  },
  {
    "Title": "Black Knight",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1990 Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "Columbus",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "House Flipper",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 220,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 112,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "CGC 9.2",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 87,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 1,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 77,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther (1977)",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther  (2005)",
    "Issue #": 2,
    "Condition": "CGC 9.8",
    "Website Notes": "1st Shuri",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Black Panther Limited Series (1988)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 100,
    "Condition": "FN+",
    "Website Notes": "1st issue",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 215,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 100,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 425,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 100,
    "Condition": "FN-",
    "Website Notes": "1st issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 100,
    "Condition": "VG/F",
    "Website Notes": "1st issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 215,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 101,
    "Condition": "NM-",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 101,
    "Condition": "VF/NM",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 101,
    "Condition": "VF+",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 101,
    "Condition": "VF-",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 101,
    "Condition": "FN",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 101,
    "Condition": "VG/F",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 102,
    "Condition": "F/VF",
    "Website Notes": "Sleeper C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 102,
    "Condition": "FN+",
    "Website Notes": "Sleeper C/S",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 102,
    "Condition": "FN",
    "Website Notes": "Sleeper C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 102,
    "Condition": "FN-",
    "Website Notes": "Sleeper C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 102,
    "Condition": "VG/F",
    "Website Notes": "Sleeper C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 103,
    "Condition": "VF",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 103,
    "Condition": "FN+",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 103,
    "Condition": "VG/F",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 104,
    "Condition": "FN",
    "Website Notes": "Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 104,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 104,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 105,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 105,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 105,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 105,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 106,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 106,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 106,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 106,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 107,
    "Condition": "VF",
    "Website Notes": "Hitler C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Vince",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "Hitler C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 107,
    "Condition": "GD",
    "Website Notes": "CPN out O/W VF",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 108,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 108,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 108,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 108,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 109,
    "Condition": "VF",
    "Website Notes": "Origin Cap",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 110,
    "Condition": "FN",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 111,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 112,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 113,
    "Condition": "VG/F",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 113,
    "Condition": "VG",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 114,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 116,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 116,
    "Condition": "VG/F",
    "Website Notes": "Avengers",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 117,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 117,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 385,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 117,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 285,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 117,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 117,
    "Condition": "CGC 5.0",
    "Website Notes": "1st Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 195,
    "": "cconect",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 117,
    "Condition": "CGC 3.5",
    "Website Notes": "1st Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 140,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 118,
    "Condition": "VF/NM",
    "Website Notes": "2nd Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 118,
    "Condition": "FN",
    "Website Notes": "2nd Falcon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 120,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 121,
    "Condition": "VF/NM",
    "Website Notes": "1st Man Brute",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 121,
    "Condition": "FN+",
    "Website Notes": "1st Man Brute",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 122,
    "Condition": "VF",
    "Website Notes": "Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 123,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 124,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 125,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 125,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 126,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 127,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 128,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 129,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 129,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 129,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 131,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 132,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 133,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 134,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 135,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 136,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 140,
    "Condition": "VF-",
    "Website Notes": "Origin Grey Gargoyle",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 142,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 143,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 144,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 153,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 154,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 155,
    "Condition": "F/VF",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 168,
    "Condition": "VF",
    "Website Notes": "1st Baron Zemu Pence Copy!",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 168,
    "Condition": "VG/F",
    "Website Notes": "1st Baron Zemu",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 176,
    "Condition": "VF/NM",
    "Website Notes": "S Rogers Quits",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 179,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 180,
    "Condition": "VF",
    "Website Notes": "1st Nomad",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 183,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 196,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 199,
    "Condition": "VG",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 241,
    "Condition": "VF/NM",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Tomlinson",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 241,
    "Condition": "VG/F",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 241,
    "Condition": "FN",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 255,
    "Condition": "NM",
    "Website Notes": "Anniversary",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 359,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 360,
    "Condition": "NM",
    "Website Notes": "1st Crossbones",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America",
    "Issue #": 360,
    "Condition": "VF/NM",
    "Website Notes": "1st Crossbones",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America Annual",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America Annual",
    "Issue #": 4,
    "Condition": "NM-",
    "Website Notes": "Magneto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America Annual",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": "Classic Zeck Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Captain America & the Campbell Kids",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "1980 giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain America Goes to War Against Drugs",
    "Issue #": "",
    "Condition": "FN",
    "Website Notes": "Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Super Skrull",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 25,
    "Condition": "VF+",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 26,
    "Condition": "FN",
    "Website Notes": "2nd Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 27,
    "Condition": "FN+",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 28,
    "Condition": "VG/F",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 28,
    "Condition": "VF",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 29,
    "Condition": "VF+",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 29,
    "Condition": "F/VF",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 30,
    "Condition": "VF",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 30,
    "Condition": "VF+",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 31,
    "Condition": "VF/NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 31,
    "Condition": "VF+",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 31,
    "Condition": "VF",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 32,
    "Condition": "VF+",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 33,
    "Condition": "VF/NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 33,
    "Condition": "CBCS 9.2",
    "Website Notes": "Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 34,
    "Condition": "F/VF",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 35,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 36,
    "Condition": "FN+",
    "Website Notes": "Watcher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 57,
    "Condition": "VF",
    "Website Notes": "vs Thor UK Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Captain Marvel",
    "Issue #": 57,
    "Condition": "F/VF",
    "Website Notes": "vs Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Captain Savage",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Cat",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "Kent Referral",
    "__1": ""
  },
  {
    "Title": "Cat",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Cat",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Cat",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Cat",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Cat",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Cat",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Chamber of Chills",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Chamber of Darkness",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Champions",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Chili Special",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Chuck Norris",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Chuck Norris",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Chuck Norris",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Classic X-Men",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Cloak & Dagger",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1983,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 1,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 4,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 6,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 7,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 60,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 10,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 13,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 13,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 14,
    "Condition": "NM",
    "Website Notes": "1st Elric",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 14,
    "Condition": "VF/NM",
    "Website Notes": "1st Elric",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 14,
    "Condition": "VF",
    "Website Notes": "1st Elric",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 15,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 15,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 17,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Trdae",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 18,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 18,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 18,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 19,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 45,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 20,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 65,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 23,
    "Condition": "NM-",
    "Website Notes": "1st Red Sonja",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 23,
    "Condition": "VF/NM",
    "Website Notes": "1st Red Sonja",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 23,
    "Condition": "VF+",
    "Website Notes": "1st Red Sonja",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 23,
    "Condition": "F/VF",
    "Website Notes": "1st Red Sonja",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 24,
    "Condition": "NM-",
    "Website Notes": "1st Red Sonja Cover",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 24,
    "Condition": "VF/NM",
    "Website Notes": "1st Red Sonja Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 24,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Red Sonja Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 25,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 28,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 29,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 33,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 34,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 35,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 37,
    "Condition": "VG",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 44,
    "Condition": "VF",
    "Website Notes": "Red Sonja",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 45,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 47,
    "Condition": "VF",
    "Website Notes": "Sub Insert",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 48,
    "Condition": "VF",
    "Website Notes": "Red Sonja",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan",
    "Issue #": 58,
    "Condition": "FN+",
    "Website Notes": "Belit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Conan Annual",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Conan Annual",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Crazy",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Creatures on the Loose",
    "Issue #": 10,
    "Condition": "CGC 9.4",
    "Website Notes": "1st King Kull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Tommy",
    "__1": ""
  },
  {
    "Title": "Creatures on the Loose",
    "Issue #": 10,
    "Condition": "NM-",
    "Website Notes": "1st King Kull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Creatures on the Loose",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "1st King Kull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Creatures on the Loose",
    "Issue #": 21,
    "Condition": "VF+",
    "Website Notes": "Steranko Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Creatures on the Loose",
    "Issue #": 30,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Creatures on the Loose",
    "Issue #": 30,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 215,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 2,
    "Condition": "CGC 7.5",
    "Website Notes": "White",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 3,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Owl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 850,
    "": "s Crowner",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "1st Owl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 4,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Purpla Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "s Crowner",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "1st Purple Man",
    "Personal Notes (Not on website)": "2 copies",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 5,
    "Condition": "FR",
    "Website Notes": "Pin Up pg missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 5,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 6,
    "Condition": "CGC 8.5",
    "Website Notes": "Mr Fear",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "Mr Fear",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Cory",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "1st Red Costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 8,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Stilt Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "1st Stilt Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 9,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 9,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 9,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 10,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 10,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 10,
    "Condition": "FA",
    "Website Notes": "Ad Page Missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 11,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 12,
    "Condition": "CGC 9.2",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "todd",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 12,
    "Condition": "FN-",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 12,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 13,
    "Condition": "GD",
    "Website Notes": "Cpn Clip",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 15,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 15,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 15,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 15,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 16,
    "Condition": "FN+",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 17,
    "Condition": "VF",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 17,
    "Condition": "FN-",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 18,
    "Condition": "VF+",
    "Website Notes": "1st Gladiator",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 18,
    "Condition": "F/VF",
    "Website Notes": "1st Gladiator",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "1st Gladiator",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 19,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 19,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 21,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 20,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 20,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 21,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 21,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 22,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 22,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 23,
    "Condition": "VF",
    "Website Notes": "Gladiator",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 23,
    "Condition": "F/VF",
    "Website Notes": "Gladiator",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 24,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 24,
    "Condition": "FN",
    "Website Notes": "CT",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 51,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 25,
    "Condition": "FN",
    "Website Notes": "1st Leap Frog",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "1st Leap Frog",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 26,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 26,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 27,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 27,
    "Condition": "FN-",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 28,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 28,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 29,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 29,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 30,
    "Condition": "VG/F",
    "Website Notes": "Thor",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 30,
    "Condition": "VG",
    "Website Notes": "Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 31,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 31,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 31,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 32,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 32,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 33,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 33,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 33,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 33,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 34,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 34,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 34,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 35,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 35,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 35,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 36,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 36,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 36,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 36,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 37,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 38,
    "Condition": "VF+",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 38,
    "Condition": "FN+",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 38,
    "Condition": "FN",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 39,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 40,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 40,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 40,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 41,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 42,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 42,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 43,
    "Condition": "FN+",
    "Website Notes": "Cap America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 44,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 44,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 44,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 44,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 44,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 45,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 45,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 45,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 46,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 46,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 48,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 48,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 49,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 50,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 50,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 52,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 53,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 53,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 57,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 57,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 58,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 59,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 60,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 61,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 60,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 61,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 62,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 62,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 63,
    "Condition": "VF+",
    "Website Notes": "Gladiator",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 63,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 65,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 66,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 66,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 67,
    "Condition": "VF",
    "Website Notes": "Stilt Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 67,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 68,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 69,
    "Condition": "VF",
    "Website Notes": "Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 69,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 70,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 70,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 71,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 71,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 72,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 72,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 72,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 73,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 73,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 74,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 74,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 76,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 77,
    "Condition": "NM-",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Holder",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 77,
    "Condition": "VF/NM",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 77,
    "Condition": "VF+",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 77,
    "Condition": "F/VF",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 77,
    "Condition": "GD",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 78,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 35,
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 78,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 78,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 79,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 79,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 80,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 80,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 80,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 81,
    "Condition": "CGC 8.5",
    "Website Notes": "Black Widow begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 81,
    "Condition": "VF+",
    "Website Notes": "Black Widow begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 81,
    "Condition": "CGC 7.5",
    "Website Notes": "Black Widow begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 81,
    "Condition": "VF",
    "Website Notes": "Black Widow begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 81,
    "Condition": "FN",
    "Website Notes": "Black Widow begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 81,
    "Condition": "VG/F",
    "Website Notes": "Black Widow begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 81,
    "Condition": "VG",
    "Website Notes": "Black Widow begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 82,
    "Condition": "NM-",
    "Website Notes": "Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 82,
    "Condition": "VF+",
    "Website Notes": "Scorpion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 82,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 83,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 83,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 83,
    "Condition": "VG/F",
    "Website Notes": "Inked",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 84,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 84,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 85,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 86,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 87,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 87,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 88,
    "Condition": "VF/NM",
    "Website Notes": "Purple Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 88,
    "Condition": "F/VF",
    "Website Notes": "Purple Man",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 88,
    "Condition": "FN",
    "Website Notes": "Purple Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 89,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 89,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 90,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 90,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 91,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 91,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 92,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 92,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 92,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 92,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 93,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 93,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 94,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 94,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 94,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 95,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 95,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 94,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 96,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 97,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 97,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 97,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 97,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 98,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 98,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 98,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 99,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 100,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "scott",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 101,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 103,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 104,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 105,
    "Condition": "FN",
    "Website Notes": "Monndragon Starlin",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 106,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 106,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 107,
    "Condition": "VF/NM",
    "Website Notes": "Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 107,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 107,
    "Condition": "GD",
    "Website Notes": "Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 108,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 108,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 108,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 109,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 109,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 110,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 111,
    "Condition": "FN",
    "Website Notes": "1st Silver Samarai",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 112,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 112,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 113,
    "Condition": "VF+",
    "Website Notes": "Gladiator",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 113,
    "Condition": "VG",
    "Website Notes": "Gladiator",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 114,
    "Condition": "NM",
    "Website Notes": "Man Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 114,
    "Condition": "VG/F",
    "Website Notes": "Man Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 115,
    "Condition": "CGC 9.8",
    "Website Notes": "Hulk 181 Ad",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 115,
    "Condition": "F/VF",
    "Website Notes": "Hulk 181 Ad",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 116,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 116,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 117,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 118,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 118,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 119,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 119,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 120,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 120,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 121,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 122,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 122,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 123,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 124,
    "Condition": "VF/NM",
    "Website Notes": "1st Copperhead",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 124,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 125,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 125,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 126,
    "Condition": "VF/NM",
    "Website Notes": "1st Torpedo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 126,
    "Condition": "VF",
    "Website Notes": "1st Torpedo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 126,
    "Condition": "VG/F",
    "Website Notes": "1st Torpedo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 127,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 127,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 128,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 128,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 128,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 129,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 129,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 130,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 130,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 130,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 131,
    "Condition": "CGC 9.6",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 131,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 131,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "George",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 131,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 290,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 131,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 131,
    "Condition": "VG",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 132,
    "Condition": "CGC 9.4",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 132,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 133,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 134,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 134,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 135,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 135,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 136,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 137,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 137,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 138,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 138,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 138,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 139,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 139,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 140,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 140,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 140,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 141,
    "Condition": "F/VF",
    "Website Notes": "Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 141,
    "Condition": "FN",
    "Website Notes": "Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 141,
    "Condition": "VG/F",
    "Website Notes": "Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 142,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 142,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 143,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 143,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 143,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 144,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 144,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 144,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 145,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 145,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": "q",
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 146,
    "Condition": "NM-",
    "Website Notes": "Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 146,
    "Condition": "VF+",
    "Website Notes": "Bullseye",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 147,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 148,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 148,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 149,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 149,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 149,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 150,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 151,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 152,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 152,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 153,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 154,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 154,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 155,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 156,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 156,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 157,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 157,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 158,
    "Condition": "F/VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 158,
    "Condition": "FN+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 159,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 160,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 161,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 162,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 162,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 163,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 165,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 165,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 166,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 166,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 167,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 167,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 168,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Elecktra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 168,
    "Condition": "CGC 9.2",
    "Website Notes": "1st Elecktra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 310,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 168,
    "Condition": "CGC 8.5",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 168,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 168,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 140,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 168,
    "Condition": "VF",
    "Website Notes": "1st Elektra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 168,
    "Condition": "CGC 7.5",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 169,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 170,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 170,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 171,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 172,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 172,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 173,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 174,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 174,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 175,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 176,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 177,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 177,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 178,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 179,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 179,
    "Condition": "VF+",
    "Website Notes": "Miller",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 180,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 180,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 181,
    "Condition": "NM+",
    "Website Notes": "Death of Elektra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 181,
    "Condition": "NM-",
    "Website Notes": "Death of Elektra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 181,
    "Condition": "VF",
    "Website Notes": "Death of Elektra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 182,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 183,
    "Condition": "NM-",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 183,
    "Condition": "VF/NM",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 183,
    "Condition": "FN+",
    "Website Notes": "Jeweler Insert",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 183,
    "Condition": "FN",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 184,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 184,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 184,
    "Condition": "FN+",
    "Website Notes": "Jeweler Insert",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 185,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 185,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 186,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 186,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 186,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 187,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 188,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 189,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 190,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 191,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 196,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 196,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 207,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 209,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 227,
    "Condition": "VF",
    "Website Notes": "Born Again Pt 1",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 229,
    "Condition": "NM-",
    "Website Notes": "Born Again Pt 3",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 232,
    "Condition": "FN",
    "Website Notes": "Born Again Pt 6",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 248,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 270,
    "Condition": "NM",
    "Website Notes": "1st Blackheart Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Cutler",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 290,
    "Condition": "NM-",
    "Website Notes": "Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 500,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil Annual",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil Annual",
    "Issue #": 2,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil Annual",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil Annual",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Daredevil Annual",
    "Issue #": 4,
    "Condition": "FN",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1998,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Daredevil Chronicles",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": 1982,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Dazzler",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "10 avail",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dead of Night",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Dead of Night",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Dead-Pool",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1997,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 4,
    "Condition": "VF+",
    "Website Notes": "Valkyrie",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 10,
    "Condition": "CGC 6.5",
    "Website Notes": "Hulk vs Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "Hulk vs Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 17,
    "Condition": "VG/F",
    "Website Notes": "1st Cameo Wrecking Crew",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 18,
    "Condition": "VF",
    "Website Notes": "Wrecking Crew",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 18,
    "Condition": "F/VF",
    "Website Notes": "Wrecking Crew",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 26,
    "Condition": "VF/NM",
    "Website Notes": "GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 38,
    "Condition": "F/VF",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Defenders",
    "Issue #": 61,
    "Condition": "VF/NM",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Devil Dinosaur",
    "Issue #": 1,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Die Spinne",
    "Issue #": 21,
    "Condition": "GD",
    "Website Notes": "German",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": "",
    "__1": ""
  },
  {
    "Title": "Die Spinne",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "German",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dino Riders",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 169,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 169,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 169,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 200,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 170,
    "Condition": "VF",
    "Website Notes": "Nightmare",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 174,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 175,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 176,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 178,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 179,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 181,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Doctor Strange",
    "Issue #": 183,
    "Condition": "VF",
    "Website Notes": "1st Undying Ones",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dr Strange",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "ashburn Ted",
    "__1": ""
  },
  {
    "Title": "Dr Strange",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "vs Defenders",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dr Strange",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Dormammu",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dr Strange",
    "Issue #": 4,
    "Condition": "NM-",
    "Website Notes": "Brunner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dr Strange",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "Brunner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dr Strange",
    "Issue #": 59,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dr Strange",
    "Issue #": 61,
    "Condition": "NM",
    "Website Notes": "Dracula",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Dr Strange Annual",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Edge of Spider-Verse",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Elektra Assassin (1986)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Mini Series",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 1,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 2,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "30 Cent Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Eternals (1976)",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Evel Knievel",
    "Issue #": "nn",
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Evel Knievel",
    "Issue #": "nn",
    "Condition": "CGC 9.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Evel Knievel",
    "Issue #": 3,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 1,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8700,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 1,
    "Condition": "G/G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6800,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 3,
    "Condition": "CGC 3.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 3,
    "Condition": "GD",
    "Website Notes": "1st Costumes",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 4,
    "Condition": "CGC 3.5",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2400,
    "": "Shu",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 5,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 16000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 5,
    "Condition": "GD",
    "Website Notes": "1st Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4500,
    "": "George",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 5,
    "Condition": "CGC 1.8",
    "Website Notes": "1st Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 7,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 9,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 9,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 140,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 12,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 13,
    "Condition": "FN-",
    "Website Notes": "1st Watcher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 13,
    "Condition": "GD",
    "Website Notes": "1st Watcher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 13,
    "Condition": "P",
    "Website Notes": "1st Watcher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 15,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 15,
    "Condition": "VG-",
    "Website Notes": "Non Story Page Out OW VG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 17,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 21,
    "Condition": "CGC 5.0",
    "Website Notes": "Sgt Fury",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 22,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 22,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 24,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 25,
    "Condition": "CGC 8.0",
    "Website Notes": "Avengers x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1750,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "Avengers x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 270,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 25,
    "Condition": "FA",
    "Website Notes": "Avengers x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Roanoke",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 26,
    "Condition": "CGC 8.0",
    "Website Notes": "Avengers x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 385,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 26,
    "Condition": "VG/F",
    "Website Notes": "Avengers x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 26,
    "Condition": "VG",
    "Website Notes": "Avengers x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 27,
    "Condition": "CGC 9.0",
    "Website Notes": "Dr Strange x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 655,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 28,
    "Condition": "CGC 9.0",
    "Website Notes": "X-Men x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 760,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 28,
    "Condition": "CGC 8.0",
    "Website Notes": "X-Men x-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 455,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 30,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 31,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 31,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 32,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 33,
    "Condition": "VG",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 33,
    "Condition": "VG-",
    "Website Notes": "Tr BC",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 33,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 33,
    "Condition": "",
    "Website Notes": "Non Story Page",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 34,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 34,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 35,
    "Condition": "P",
    "Website Notes": "1st page missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 36,
    "Condition": "VF",
    "Website Notes": "1st Medusa",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 36,
    "Condition": "FN",
    "Website Notes": "1st Medusa",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "1st Medusa",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 36,
    "Condition": "GD",
    "Website Notes": "non story page missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 37,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 37,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 37,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 38,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 38,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 38,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 39,
    "Condition": "F/VF",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 39,
    "Condition": "CGC 5.5",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 108,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 39,
    "Condition": "VG",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 40,
    "Condition": "FN",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 40,
    "Condition": "VG/F",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 40,
    "Condition": "VG",
    "Website Notes": "Daredevil",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 41,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 41,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 41,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 42,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 43,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 43,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 43,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 44,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 45,
    "Condition": "CBCS 5.0",
    "Website Notes": "1st Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 265,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 45,
    "Condition": "FN-",
    "Website Notes": "1st Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 312,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 45,
    "Condition": "VG/F",
    "Website Notes": "1st Inhumans",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 280,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 45,
    "Condition": "VG",
    "Website Notes": "1st Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 45,
    "Condition": "CGC 4.0",
    "Website Notes": "1st Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 46,
    "Condition": "VG/F",
    "Website Notes": "1st Black Bolt",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 215,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 46,
    "Condition": "FN+",
    "Website Notes": "1st Black Bolt",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 255,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 46,
    "Condition": "G/VG",
    "Website Notes": "1st Black Bolt",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 47,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 57,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 47,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 76,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 48,
    "Condition": "CGC 4.0",
    "Website Notes": "1st Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 48,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 48,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 48,
    "Condition": "CGC 3.5",
    "Website Notes": "1st Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 375,
    "": "Jess",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 48,
    "Condition": "VG-",
    "Website Notes": "1st Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 48,
    "Condition": "GD",
    "Website Notes": "non story page out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 49,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 49,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 49,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 49,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 220,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 49,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 50,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 50,
    "Condition": "VG+",
    "Website Notes": "S Surfer C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 50,
    "Condition": "VG",
    "Website Notes": "S Surfer C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 51,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 44,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 51,
    "Condition": "P/F",
    "Website Notes": "Non Story Page Out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 52,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 52,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1675,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 52,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1300,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 52,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 765,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 52,
    "Condition": "VG+",
    "Website Notes": "1st Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 52,
    "Condition": "CGC 4.0",
    "Website Notes": "1st Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 53,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 55,
    "Condition": "F/VF",
    "Website Notes": "Silver Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 55,
    "Condition": "VG/F",
    "Website Notes": "Silver Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 55,
    "Condition": "VG+",
    "Website Notes": "Silver Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 56,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 56,
    "Condition": "VG",
    "Website Notes": "CF out O/W VG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 57,
    "Condition": "FN+",
    "Website Notes": "Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 57,
    "Condition": "VG/F",
    "Website Notes": "Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 57,
    "Condition": "VG",
    "Website Notes": "Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 58,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 59,
    "Condition": "VG/F",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 59,
    "Condition": "VG",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 60,
    "Condition": "CGC 7.5",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "Pedigree",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 60,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 61,
    "Condition": "F/VF",
    "Website Notes": "Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 61,
    "Condition": "FN+",
    "Website Notes": "Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 62,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 63,
    "Condition": "FN+",
    "Website Notes": "Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 63,
    "Condition": "GD",
    "Website Notes": "Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 64,
    "Condition": "FN+",
    "Website Notes": "1st Kree Sentry",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 64,
    "Condition": "FN",
    "Website Notes": "1st Kree Sentry",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 65,
    "Condition": "FN",
    "Website Notes": "1st Ronan",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Ann Arbor",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 66,
    "Condition": "FN+",
    "Website Notes": "Him",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 66,
    "Condition": "VG",
    "Website Notes": "Him",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "George",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 67,
    "Condition": "CGC 7.5",
    "Website Notes": "Him/Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 68,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 69,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 69,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 69,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 69,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 70,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 70,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 71,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 71,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 72,
    "Condition": "FN+",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 170,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 72,
    "Condition": "VG/F",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 72,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 73,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 75,
    "Condition": "VG/F",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 75,
    "Condition": "VG",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 76,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 76,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 77,
    "Condition": "VF",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 77,
    "Condition": "F/VF",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 77,
    "Condition": "FN+",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 77,
    "Condition": "FN-",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 77,
    "Condition": "FN-",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 77,
    "Condition": "VG/F",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 78,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 79,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 79,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 79,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 80,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 80,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 80,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 80,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 81,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 81,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 81,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 82,
    "Condition": "VG",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 83,
    "Condition": "FN",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 83,
    "Condition": "VG/F",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 83,
    "Condition": "GD+",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 84,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 84,
    "Condition": "VG",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 85,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 85,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 85,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 86,
    "Condition": "CGC 7.5",
    "Website Notes": "Classic Dr Doom Cvr",
    "Personal Notes (Not on website)": "Pedigree",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 86,
    "Condition": "FN",
    "Website Notes": "Classic Dr Doom Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 86,
    "Condition": "VG/F",
    "Website Notes": "Classic Dr Doom Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 86,
    "Condition": "VG+",
    "Website Notes": "Classic Dr Doom Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 87,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 87,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 87,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 87,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 87,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 88,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 88,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 88,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 88,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 88,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 89,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 90,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 90,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 91,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 91,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 91,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 92,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 92,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 93,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 93,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 94,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 94,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 95,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 95,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 96,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 96,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 97,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 98,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 98,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 98,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 99,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 100,
    "Condition": "FN+",
    "Website Notes": "Anniversary Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 100,
    "Condition": "VG",
    "Website Notes": "Anniversary Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 101,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 102,
    "Condition": "FN+",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 102,
    "Condition": "VG/F",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 103,
    "Condition": "VG/F",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 104,
    "Condition": "VF/NM",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 104,
    "Condition": "VF",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 104,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 105,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 105,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 108,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 108,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 109,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 109,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 110,
    "Condition": "CGC 9.2",
    "Website Notes": "Green Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1360,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 110,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 111,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 112,
    "Condition": "CGC 8.5",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "Hakes",
    "Cost Basis": 638,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 112,
    "Condition": "VF",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 112,
    "Condition": "FN+",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 220,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 112,
    "Condition": "VG/F",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 113,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 113,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 114,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 114,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 114,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 115,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 115,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 6,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 116,
    "Condition": "CGC 9.0",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 116,
    "": "Comiclink",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 116,
    "Condition": "VF",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 116,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 116,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 116,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 116,
    "Condition": "VG",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 117,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 118,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 118,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 119,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 119,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 120,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 120,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 121,
    "Condition": "FN+",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 122,
    "Condition": "F/VF",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 123,
    "Condition": "F/VF",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 124,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 124,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 125,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 125,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 126,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 126,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 127,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 127,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 127,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 128,
    "Condition": "F/VF",
    "Website Notes": "w/insert",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 128,
    "Condition": "VG/F",
    "Website Notes": "w/insert",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 129,
    "Condition": "FN",
    "Website Notes": "1st Thundra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 129,
    "Condition": "VG/F",
    "Website Notes": "1st Thundra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 129,
    "Condition": "VG",
    "Website Notes": "1st Thundra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 130,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 130,
    "Condition": "FN",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 131,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 131,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 131,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 132,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 132,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 133,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 134,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 134,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 135,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 136,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 136,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 137,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 137,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 137,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 138,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 138,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 139,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 139,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 140,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 140,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 141,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 141,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 142,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 143,
    "Condition": "FN",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 144,
    "Condition": "VF+",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 145,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 145,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 146,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 146,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 147,
    "Condition": "VF-",
    "Website Notes": "Thing VS Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 148,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 148,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 149,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 149,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 150,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 150,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 151,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 152,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 152,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 152,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 154,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 155,
    "Condition": "VF/NM",
    "Website Notes": "S Surfer C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 155,
    "Condition": "F/VF",
    "Website Notes": "S Surfer C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 155,
    "Condition": "FN",
    "Website Notes": "S Surfer C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 155,
    "Condition": "VG/F",
    "Website Notes": "S Surfer C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 156,
    "Condition": "VF",
    "Website Notes": "Doom Surfer",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 157,
    "Condition": "VF/NM",
    "Website Notes": "Doom Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 157,
    "Condition": "VF",
    "Website Notes": "Doom Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 157,
    "Condition": "FN+",
    "Website Notes": "Doom Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 158,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 159,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 159,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 160,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 160,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 161,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 162,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 163,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 164,
    "Condition": "VF/NM",
    "Website Notes": "Marvel Boy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 165,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 165,
    "Condition": "F/VF",
    "Website Notes": "1st Quasar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 165,
    "Condition": "FN+",
    "Website Notes": "1st Quasar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 165,
    "Condition": "FN",
    "Website Notes": "1st Quasar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 165,
    "Condition": "VG/F",
    "Website Notes": "1st Quasar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 166,
    "Condition": "VF/NM",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 166,
    "Condition": "VF",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 166,
    "Condition": "F/VF",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 166,
    "Condition": "VG/F",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 167,
    "Condition": "VF/NM",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 167,
    "Condition": "FN+",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 167,
    "Condition": "FN",
    "Website Notes": "Thing vs Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 168,
    "Condition": "VF/NM",
    "Website Notes": "Power Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 168,
    "Condition": "F/VF",
    "Website Notes": "Power Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 169,
    "Condition": "VF/NM",
    "Website Notes": "Power Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 169,
    "Condition": "G/VG",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 170,
    "Condition": "VF+",
    "Website Notes": "Power Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 171,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 172,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 173,
    "Condition": "VF/NM",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 174,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 175,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 176,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 178,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 178,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 180,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 181,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 181,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 183,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 184,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 185,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 186,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 188,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 189,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 190,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 192,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 193,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 194,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 200,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": "200-238",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 243,
    "Condition": "VF",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 243,
    "Condition": "F/VF",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 243,
    "Condition": "VG/F",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 244,
    "Condition": "VF+",
    "Website Notes": "1st Nova(2nd)",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 286,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "1-",
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 292,
    "Condition": "NM-",
    "Website Notes": "Hitler Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 296,
    "Condition": "NM",
    "Website Notes": "Anniversary Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 352,
    "Condition": "NM-",
    "Website Notes": "1st Cameo Mobius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 358,
    "Condition": "NM+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 358,
    "Condition": "NM",
    "Website Notes": "Newsstannd",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "Columbus",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": 400,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 2,
    "Condition": "CGC 5.0",
    "Website Notes": "Origin Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 560,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 2,
    "Condition": "VG-",
    "Website Notes": "Origin Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "Wedding",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "1st Solo Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 5,
    "Condition": "VG+",
    "Website Notes": "1st Solo Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "1st Solo Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 5,
    "Condition": "CBCS 9.4",
    "Website Notes": "1st Solo Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 390,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 6,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 256,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 6,
    "Condition": "CBCS 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "George",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Annual",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Fantastic Four",
    "Issue #": "1/2",
    "Condition": "NM",
    "Website Notes": "Wizard",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantastic Four Power Record",
    "Issue #": "PR13",
    "Condition": "VF/NM",
    "Website Notes": "w/Record",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Fantasy Masterpieces",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 76,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantasy Masterpieces",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fantasy Masterpieces",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "palm springs",
    "__1": ""
  },
  {
    "Title": "Fantasy Masterpieces",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Fantasy Masterpieces",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "Fin Fang Foom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fin Fang Foom",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fin Fang Foom",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fin Fang Foom",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fear",
    "Issue #": 10,
    "Condition": "F/VF",
    "Website Notes": "Man Thing begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Fear",
    "Issue #": 19,
    "Condition": "CGC 9.0",
    "Website Notes": "Howard the Duck",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fear",
    "Issue #": 19,
    "Condition": "VF+",
    "Website Notes": "Howard the Duck",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Fear",
    "Issue #": 20,
    "Condition": "CGC 9.6",
    "Website Notes": "Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fear",
    "Issue #": 20,
    "Condition": "VF",
    "Website Notes": "Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fear",
    "Issue #": 20,
    "Condition": "FN+",
    "Website Notes": "Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Flinstone Kids",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Star Comics",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Frankenstein",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Ploog C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Frankenstein",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Ploog C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Frankenstein",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Ploog C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Frankenstein",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Frankenstein",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Frankenstein",
    "Issue #": 4,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Frankenstein",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 6,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Palm Beach",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 7,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Palm Beach",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Palm Beach",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 10,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Fun and Games",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Galactus (Super-Villain Classics)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": 1983,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Gambit (1993)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Get Along Gang",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Star Comics",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "tommy",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 5,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 6,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 7,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1967)",
    "Issue #": 7,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1972)",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1972)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1972)",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1972)",
    "Issue #": 20,
    "Condition": "VF+",
    "Website Notes": "DD X-Over",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 17,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1972)",
    "Issue #": 81,
    "Condition": "VF/NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Nick GE",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1990)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1990)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ghost Rider (1990)",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 311,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Avengers",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "Vision/Scarlet Witch Wedding",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Giant-Size Chillers",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "1st Lillith",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Giant-Size Creatures",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Tigra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Stan",
    "__1": ""
  },
  {
    "Title": "Giant-Size Daredevil",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 21,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Master of Kung Fu",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Spider-Man",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 21,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Spider-Man",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 21,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Spider-Man",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "3rd Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Spider-Man",
    "Issue #": 4,
    "Condition": "CGC 9.4",
    "Website Notes": "3rd Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Spider-Man",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "3rd Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 95,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Spider-Man",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 21,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Super-Heroes",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Super-Heroes",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Giant-Size Super-Heroes",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size Super-Villain Team-Up",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 1,
    "Condition": "CGC 8.0",
    "Website Notes": "1st New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 1,
    "Condition": "CGC 6.5",
    "Website Notes": "1st New X-Men",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 2000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 1,
    "Condition": "CGC 5.5",
    "Website Notes": "1st New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 1,
    "Condition": "CGC 5.0",
    "Website Notes": "1st New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3530,
    "": "",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "1st New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1400,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 1,
    "Condition": "CGC 3.0",
    "Website Notes": "1st New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "1st New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 750,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Giant-Size X-Men",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "GI Joe Real American Hero",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 270,
    "": "",
    "__1": ""
  },
  {
    "Title": "GI Joe Real American Hero",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "GI Joe Real American Hero",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "GI Joe Real American Hero",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "GI Joe Real American Hero",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "GI Joe Real American Hero",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "GI Joe Real American Hero",
    "Issue #": 21,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 9,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 12,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 14,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 16,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 17,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 19,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Guardians of the Galaxy",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1990,
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hanna Barbera's Laff-A-Lympics",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hawkeye",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hawkeye",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hawkeye",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hawkeye",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hercules",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Limited Series",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "CGC 9.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Ray",
    "Cost Basis": 750,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 380,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 340,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "AnnArbor",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 160,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 14,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Hero for Hire",
    "Issue #": 16,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 4,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 10,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 11,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 12,
    "Condition": "F/VF",
    "Website Notes": "KISS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 13,
    "Condition": "NM",
    "Website Notes": "1st Full KISS",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "Kent",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 13,
    "Condition": "NM-",
    "Website Notes": "1st Full KISS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "1st Ful KISS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 14,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 16,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 17,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 20,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 24,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 27,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 31,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Howard the Duck",
    "Issue #": 33,
    "Condition": "NM",
    "Website Notes": "last Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Howard the Duck Annual",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Human Torch (1975)",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 1,
    "Condition": "CBCS 2.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 9000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 2,
    "Condition": "CGC 4.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2100,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 3,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2300,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 4,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 4,
    "Condition": "CGC 4.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 4,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "George",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 5,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 1280,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 6,
    "Condition": "CGC 6.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 630,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 6,
    "Condition": "CGC 3.0",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 375,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 6,
    "Condition": "G/VG",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 102,
    "Condition": "FN",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 103,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 103,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 104,
    "Condition": "F/VF",
    "Website Notes": "Rhino",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 104,
    "Condition": "FN",
    "Website Notes": "Lower Staple Pull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 106,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 107,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 108,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 110,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 113,
    "Condition": "FN+",
    "Website Notes": "Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 116,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 118,
    "Condition": "VF",
    "Website Notes": "vs Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 121,
    "Condition": "VF/NM",
    "Website Notes": "The Glob",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 122,
    "Condition": "FN+",
    "Website Notes": "Hulk vs Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 122,
    "Condition": "FN",
    "Website Notes": "Hulk vs Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 122,
    "Condition": "VF",
    "Website Notes": "Hulk vs Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 126,
    "Condition": "FN+",
    "Website Notes": "1st Valkyrie",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 131,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 137,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 138,
    "Condition": "FN+",
    "Website Notes": "Sandman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 140,
    "Condition": "VF/NM",
    "Website Notes": "1st Jarella",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 141,
    "Condition": "VF/NM",
    "Website Notes": "1st Doc Samson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 141,
    "Condition": "FN",
    "Website Notes": "1st Doc Samson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 144,
    "Condition": "VF/NM",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Tommy",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 144,
    "Condition": "VF+",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 147,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 154,
    "Condition": "CGC 9.0",
    "Website Notes": "Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 154,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 157,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 158,
    "Condition": "VF-",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 160,
    "Condition": "VF",
    "Website Notes": "Tiger Shark",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 161,
    "Condition": "CGC 9.6",
    "Website Notes": "Beast",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 210,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 161,
    "Condition": "CGC 9.4",
    "Website Notes": "Beast",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 161,
    "Condition": "F/VF",
    "Website Notes": "Beast",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 162,
    "Condition": "F/VF",
    "Website Notes": "1st Wendigo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 172,
    "Condition": "VF+",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 174,
    "Condition": "VF+",
    "Website Notes": "Cobalt Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 175,
    "Condition": "CGC 9.6",
    "Website Notes": "Mile High II",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 175,
    "Condition": "VF",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 177,
    "Condition": "NM-",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 178,
    "Condition": "VF",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 180,
    "Condition": "CGC 9.0",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 180,
    "Condition": "CGC 6.5",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 181,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 181,
    "Condition": "CGC 7.0",
    "Website Notes": "1st Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 181,
    "Condition": "CGC 6.5",
    "Website Notes": "1st Wolverine",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 2900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 181,
    "Condition": "CGC 3.0",
    "Website Notes": "1st Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 181,
    "Condition": "CGC .5",
    "Website Notes": "1st Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 182,
    "Condition": "CGC 8.5",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 182,
    "Condition": "CGC 7.5",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 191,
    "Condition": "VF/NM",
    "Website Notes": "Toad",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 197,
    "Condition": "VF",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 201,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 210,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 234,
    "Condition": "VF+",
    "Website Notes": "1st Quasar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 250,
    "Condition": "NM",
    "Website Notes": "Silver Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 250,
    "Condition": "F/VF",
    "Website Notes": "Silver Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 251,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 254,
    "Condition": "VF",
    "Website Notes": "1st U-Foes",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 271,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 282,
    "Condition": "VF+",
    "Website Notes": "She-Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 324,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 325,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 330,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 330,
    "Condition": "NM",
    "Website Notes": "McFarlane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 340,
    "Condition": "VF+",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": 449,
    "Condition": "VF+",
    "Website Notes": "1st Thunderbolts",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 1,
    "Condition": "CGC 7.0",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 315,
    "": "Pedigree",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 1,
    "Condition": "VG+",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "2nd Groot",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Bob",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "2nd Groot",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 5,
    "Condition": "FN+",
    "Website Notes": "2nd Groot",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "2nd Groot",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 6,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "Capt Universe",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk Annual",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "Miler Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Incredible Hulk",
    "Issue #": "Wizard Ace",
    "Condition": "NM",
    "Website Notes": "Hulk 181",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Infinity Gauntlet",
    "Issue #": "1-6 Set",
    "Condition": "NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Infinity Gauntlet",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Infinity Gauntlet",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Infinity Gauntlet",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Infinity Gauntlet",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Infinity War",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Inhumans (1975)",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Inhumans (1975)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Inhumans (1975)",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Invaders",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Invaders",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Invaders",
    "Issue #": 14,
    "Condition": "VF/NM",
    "Website Notes": "1st Crusaders",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Iron Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 1,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 220,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 14,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Sabretooth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 14,
    "Condition": "CGC 9.0",
    "Website Notes": "Lee/Claremont SS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 14,
    "Condition": "VF/NM",
    "Website Notes": "1st Sabretooth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 14,
    "Condition": "VF+",
    "Website Notes": "1st Sabretooth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 14,
    "Condition": "F/VF",
    "Website Notes": "1st Sabretooth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 15,
    "Condition": "VF+",
    "Website Notes": "Byrne X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 15,
    "Condition": "VF",
    "Website Notes": "Byrne X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "BCC",
    "__1": ""
  },
  {
    "Title": "Iron Fist",
    "Issue #": 15,
    "Condition": "VG-",
    "Website Notes": "Byrne X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 1,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 560,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 1,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 490,
    "": "Pedigree",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 1,
    "Condition": "CGC 4.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 2,
    "Condition": "CGC 9.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 2,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 4,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 5,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 6,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 7,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 15,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 16,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 17,
    "Condition": "VF",
    "Website Notes": "1st Madam Masque",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 17,
    "Condition": "VG/F",
    "Website Notes": "1st Madam Masque",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 19,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 20,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 21,
    "Condition": "F/VF",
    "Website Notes": "Crimson Dynamo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 22,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 25,
    "Condition": "VF/NM",
    "Website Notes": "vs Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 25,
    "Condition": "VF",
    "Website Notes": "vs Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 31,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 33,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 36,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 38,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 39,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 47,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 17,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 47,
    "Condition": "FN+",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 47,
    "Condition": "FN",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 54,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 55,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 55,
    "Condition": "F/VF",
    "Website Notes": "1st Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 55,
    "Condition": "VG/F",
    "Website Notes": "1st Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 55,
    "Condition": "VG",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 66,
    "Condition": "VF",
    "Website Notes": "vs Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 88,
    "Condition": "FN",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 95,
    "Condition": "VF/NM",
    "Website Notes": "Ultimo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 106,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 107,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 108,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 109,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 112,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 117,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 119,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 120,
    "Condition": "NM",
    "Website Notes": "Sub-Mariner",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man",
    "Issue #": 282,
    "Condition": "CGC 9.8",
    "Website Notes": "1st War Machine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Iron Man & Sub-Mariner",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": 1968,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 214,
    "": "",
    "__1": ""
  },
  {
    "Title": "John Carter Warlord of Mars",
    "Issue #": 28,
    "Condition": "NM",
    "Website Notes": "Last Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 15,
    "Condition": "GD+",
    "Website Notes": "Heath Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 40,
    "Condition": "GD",
    "Website Notes": "Everett Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 43,
    "Condition": "CGC 8.0",
    "Website Notes": "Inv Girl Protoype",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 47,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 51,
    "Condition": "G/VG",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 56,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 60,
    "Condition": "FN-",
    "Website Notes": "BOMBU",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 60,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 62,
    "Condition": "FN",
    "Website Notes": "Hulk Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 62,
    "Condition": "FA",
    "Website Notes": "Last Page Out O/W VG/F",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 63,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 63,
    "Condition": "G/VG",
    "Website Notes": "Extra staples",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 63,
    "Condition": "F/G",
    "Website Notes": "GOLIATH",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 65,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 65,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 65,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 67,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ogden Trade",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 67,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 68,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 69,
    "Condition": "VG/F",
    "Website Notes": "Korilla",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 70,
    "Condition": "VG+",
    "Website Notes": "Sandman Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 71,
    "Condition": "FN",
    "Website Notes": "ROC",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 72,
    "Condition": "VG/F",
    "Website Notes": "GLOB",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 72,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 74,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 74,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 75,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 76,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 78,
    "Condition": "VG/F",
    "Website Notes": "Dr Strange Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 79,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 80,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 80,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 81,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "TBC",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 83,
    "Condition": "CGC 4.5",
    "Website Notes": "1st Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 84,
    "Condition": "VG/F",
    "Website Notes": "1st Jane Foster",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1525,
    "": "comic logic",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 86,
    "Condition": "CBCS 7.0",
    "Website Notes": "1st Odin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 455,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 86,
    "Condition": "VG/F",
    "Website Notes": "1st Odin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 87,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 88,
    "Condition": "VG/F",
    "Website Notes": "2nd Loki Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 89,
    "Condition": "CGC 6.0",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 89,
    "Condition": "VG/F",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 89,
    "Condition": "GD",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 90,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 91,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 91,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 92,
    "Condition": "VG",
    "Website Notes": "Loki Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 92,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 93,
    "Condition": "G-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 93,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 93,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 93,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 94,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 95,
    "Condition": "VG+",
    "Website Notes": "Thor vs Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 96,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 97,
    "Condition": "FN+",
    "Website Notes": "Tales of Asgard",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 97,
    "Condition": "G/VG",
    "Website Notes": "Tales of Asgard",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 98,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Human Cobra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 98,
    "Condition": "F/VF",
    "Website Notes": "1st Human Cobra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 98,
    "Condition": "G/VG",
    "Website Notes": "1st Human Cobra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 99,
    "Condition": "F/VF",
    "Website Notes": "1st Mr Hyde",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 99,
    "Condition": "VG/F",
    "Website Notes": "1st Mr Hyde",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 100,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 101,
    "Condition": "FN+",
    "Website Notes": "Avengers X-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 101,
    "Condition": "G/VG",
    "Website Notes": "Avengers X-over",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 102,
    "Condition": "VF",
    "Website Notes": "1st Balder, Sif, Hela",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 102,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Balder, Sif, Hela",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 102,
    "Condition": "VG-",
    "Website Notes": "1st Balder, Sif, Hela",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 355,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 103,
    "Condition": "VG/F",
    "Website Notes": "1st Enchantress",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 103,
    "Condition": "VG",
    "Website Notes": "1st Enchantress",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 104,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 106,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 106,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 106,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "1st Grey Gargoyle",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 107,
    "Condition": "VG",
    "Website Notes": "1st Grey Gargoyle",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 108,
    "Condition": "VG/F",
    "Website Notes": "1st King Sidri",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 108,
    "Condition": "VG",
    "Website Notes": "1st King Sidri",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 109,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 109,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 109,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 110,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 110,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 110,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 111,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 28,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 112,
    "Condition": "G/VG",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 112,
    "Condition": "VG+",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 112,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 112,
    "Condition": "VG/F",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 112,
    "Condition": "FN",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 155,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 113,
    "Condition": "FN+",
    "Website Notes": "Origin Loki",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 113,
    "Condition": "FN-",
    "Website Notes": "Origin Loki",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 114,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 114,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 115,
    "Condition": "VG/F",
    "Website Notes": "Origin Loki",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 116,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 117,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 17,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 118,
    "Condition": "VG/F",
    "Website Notes": "1st Destroyer",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 119,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 120,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 120,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 121,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 121,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 122,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 123,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery",
    "Issue #": 123,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Journey into Mystery Annual",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "1st Hercules",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 255,
    "": "",
    "__1": ""
  },
  {
    "Title": "Jungle Action",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "Panther begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Jungle Action",
    "Issue #": 6,
    "Condition": "VF+",
    "Website Notes": "1st Kill-Monger",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Jungle Action",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "1st Kill-Monger",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Jungle Action",
    "Issue #": 7,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Jungle Action",
    "Issue #": 23,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Jungle Action",
    "Issue #": 24,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 100,
    "Condition": "FN+",
    "Website Notes": "UK Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 102,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 107,
    "Condition": "G/VG",
    "Website Notes": "Kirby Monster Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 111,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 116,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 118,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 126,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kid Colt Outlaw",
    "Issue #": 127,
    "Condition": "CGC 8.0",
    "Website Notes": "Iron Mask",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Wood art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 2,
    "Condition": "Vf/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 5,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 7,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 8,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 14,
    "Condition": "VF+",
    "Website Notes": "Starlin C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 16,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 21,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Kull the Conqueror",
    "Issue #": 22,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Li'l Kids",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Tommy",
    "__1": ""
  },
  {
    "Title": "Li'l Kids",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Logans Run",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Logans Run",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Logans Run",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Logans Run",
    "Issue #": 6,
    "Condition": "CGC 9.0",
    "Website Notes": "Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Longshot",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Limited Series",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "Machine Man",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Machine Man",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Machine Man",
    "Issue #": 12,
    "Condition": "NM",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Machine Man",
    "Issue #": 15,
    "Condition": "NM",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Machine Man",
    "Issue #": 17,
    "Condition": "NM",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Machine Man",
    "Issue #": 18,
    "Condition": "NM",
    "Website Notes": "Alpha Flight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Machine Man",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "Jack O Lantern",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Mad About Millie Annual",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "Highest Graded",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 345,
    "": "Pedigree",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "Ploog",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 8,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 19,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man -Thing (1974)",
    "Issue #": 22,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Man-Thing (1979)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marc Spector: Moon Knight",
    "Issue #": 25,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "Marvel Age",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Age",
    "Issue #": 13,
    "Condition": "NM",
    "Website Notes": "Dreadstar",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Age",
    "Issue #": 14,
    "Condition": "NM",
    "Website Notes": "Byrne",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Age",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "Spidey Black C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Age",
    "Issue #": 22,
    "Condition": "NM",
    "Website Notes": "Sol Brodsky",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Age",
    "Issue #": 38,
    "Condition": "NM-",
    "Website Notes": "He-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Chillers",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Chillers",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "Tigra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Comics Collectors Edition",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "7-11 giveawy 1981",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Comics Presents",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Comics Presents",
    "Issue #": 72,
    "Condition": "CGC 9.8",
    "Website Notes": "Weapon X",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 203,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Comics Presents",
    "Issue #": 72,
    "Condition": "VF/NM",
    "Website Notes": "Weapon X",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Comics Presents",
    "Issue #": 168,
    "Condition": "NM",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Double Feature",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "1st Defenders",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 90,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Marvel Feature",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "1st Defenders",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "1st Defenders",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "1st Defenders",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Marvel Feature",
    "Issue #": 11,
    "Condition": "FN",
    "Website Notes": "Thing VS Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Feature (1976)",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature (1976)",
    "Issue #": 4,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature (1976)",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature (1976)",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature (1976)",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Feature (1976)",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Dreadstar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 4,
    "Condition": "CGC 8.0",
    "Website Notes": "1st New Mutants",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 18,
    "Condition": "NM",
    "Website Notes": "She-Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": "Daredevil",
    "Condition": "VF/NM",
    "Website Notes": "2nd print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Knights",
    "Issue #": "Special Edition",
    "Condition": "NM",
    "Website Notes": "Wizard",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Milestone Edition",
    "Issue #": "FF1",
    "Condition": "NM",
    "Website Notes": "Fantastic Four 1",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Milestone Edition",
    "Issue #": "X-Men 1",
    "Condition": "VF/NM",
    "Website Notes": "Stan Lee SS w/COA",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel's Greatest Comics",
    "Issue #": 39,
    "Condition": "VF-",
    "Website Notes": "Reprints 1st Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Marvel's Greatest Comics",
    "Issue #": 64,
    "Condition": "FN",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 1,
    "Condition": "CGC 9.2",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 355,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "Dr Strange",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 15,
    "Condition": "CGC 9.4",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 265,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 15,
    "Condition": "CGC 8.5",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 630,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 15,
    "Condition": "VF+",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 15,
    "Condition": "CGC 7.0",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 15,
    "Condition": "FN",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 19,
    "Condition": "VF+",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 20,
    "Condition": "VF/NM",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 21,
    "Condition": "VF/NM",
    "Website Notes": "1st Misty Knight",
    "Personal Notes (Not on website)": "2 Avail",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 24,
    "Condition": "VF/NM",
    "Website Notes": "Satana c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 28,
    "Condition": "NM",
    "Website Notes": "Legion of Monsters",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Holder",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 28,
    "Condition": "VF/NM",
    "Website Notes": "Legion of Monsters",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 170,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 28,
    "Condition": "VF",
    "Website Notes": "Legion of Monsters",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 30,
    "Condition": "F/VF",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 47,
    "Condition": "NM-",
    "Website Notes": "Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 47,
    "Condition": "VG/F",
    "Website Notes": "Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 48,
    "Condition": "F/VF",
    "Website Notes": "Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 50,
    "Condition": "VF/NM",
    "Website Notes": "Alice Cooper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 50,
    "Condition": "NM-",
    "Website Notes": "Alice Cooper",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 50,
    "Condition": "F/VF",
    "Website Notes": "Alice Cooper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 52,
    "Condition": "VF/NM",
    "Website Notes": "Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Premiere",
    "Issue #": 53,
    "Condition": "NM",
    "Website Notes": "Black Panther",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Presents",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Presents",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Presents",
    "Issue #": 10,
    "Condition": "NM-",
    "Website Notes": "GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 14,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvels Greatest Comics",
    "Issue #": 42,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvels Greatest Comics",
    "Issue #": 64,
    "Condition": "VG",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spectacular",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Red Wolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 2,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 2,
    "Condition": "PGX 8.5",
    "Website Notes": "Adams SS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 285,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "2nd WBN",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 5,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 5,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "Stain BC OW VF",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 725,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "1st Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 5,
    "Condition": "FN-",
    "Website Notes": "1st Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "1st Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 5,
    "Condition": "VG-",
    "Website Notes": "1st Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "BCC Trade",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 6,
    "Condition": "CGC 8.5",
    "Website Notes": "2nd Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "2nd Ghost Rider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 9,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 11,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 12,
    "Condition": "CGC 9.4",
    "Website Notes": "Son of Satan",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 12,
    "Condition": "FN",
    "Website Notes": "Son of Satan",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 12,
    "Condition": "FN+",
    "Website Notes": "Son of Satan",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 14,
    "Condition": "VF+",
    "Website Notes": "Son of Satan",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 22,
    "Condition": "NM-",
    "Website Notes": "Satana Cvr",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 22,
    "Condition": "CGC 9.4",
    "Website Notes": "Winnipeg Copy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 22,
    "Condition": "FN",
    "Website Notes": "Satana Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 24,
    "Condition": "VF",
    "Website Notes": "Satana Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 26,
    "Condition": "NM",
    "Website Notes": "Scarecrow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 26,
    "Condition": "VF/NM",
    "Website Notes": "Scarecrow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "BCC",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 28,
    "Condition": "VF",
    "Website Notes": "Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 29,
    "Condition": "F/VF",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 31,
    "Condition": "NM-",
    "Website Notes": "Nick Fury",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 32,
    "Condition": "CGC 9.6",
    "Website Notes": "Spider-Woman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight",
    "Issue #": 32,
    "Condition": "VG/F",
    "Website Notes": "Spider-Woman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Spotlight (1979)",
    "Issue #": 6,
    "Condition": "VF+",
    "Website Notes": "1st Starlord in comics",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Action",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": 1966,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 12,
    "Condition": "VF+",
    "Website Notes": "1st Cap Marvel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 13,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 14,
    "Condition": "VF+",
    "Website Notes": "Spider-man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 15,
    "Condition": "FN+",
    "Website Notes": "Medusa",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 17,
    "Condition": "G/VG",
    "Website Notes": "Black Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 18,
    "Condition": "F/VF",
    "Website Notes": "1st GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 18,
    "Condition": "CGC 6.0",
    "Website Notes": "1st GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 18,
    "Condition": "FN",
    "Website Notes": "1st GOTG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 57,
    "Condition": "VG",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes Secret Wars",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes Secret Wars",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "Spider Woman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes Secret Wars",
    "Issue #": 8,
    "Condition": "CGC 9.8",
    "Website Notes": "Black Costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes Secret Wars",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Marvel Super Heroes",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "1st Squirrel Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Tails",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Tales",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 568,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Tales",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Tales",
    "Issue #": 68,
    "Condition": "FN",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Tales",
    "Issue #": 69,
    "Condition": "VG+",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Tales",
    "Issue #": 69,
    "Condition": "VG/F",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Tales",
    "Issue #": 138,
    "Condition": "CGC 9.4",
    "Website Notes": "ASM 1 Reprint",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "White Pgs",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "4th app Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 3,
    "Condition": "NM-",
    "Website Notes": "4th app Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "4th app Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "Kang Cvr/Sty",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "Kang Cvr/Sty",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Beyond",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "Werewolf",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 53,
    "Condition": "VG/F",
    "Website Notes": "Byrne X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 82,
    "Condition": "CGC 9.8",
    "Website Notes": "Black Widow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 95,
    "Condition": "VF+",
    "Website Notes": "1st Mockingbird",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 95,
    "Condition": "VF/NM",
    "Website Notes": "1st Mockingbird",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 100,
    "Condition": "NM",
    "Website Notes": "1st Karma",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 117,
    "Condition": "NM-",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 141,
    "Condition": "NM-",
    "Website Notes": "2nd Black Costume",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 141,
    "Condition": "VF/NM",
    "Website Notes": "2nd Black Costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up",
    "Issue #": 141,
    "Condition": "VF/NM",
    "Website Notes": "NEWSSTAND",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Annandale",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up Annual",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Team Up Annual",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Triple Action",
    "Issue #": 4,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Triple Action",
    "Issue #": 29,
    "Condition": "VF+",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Triple Action",
    "Issue #": 29,
    "Condition": "VG/F",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 15,
    "Condition": "CGC 5.0",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 16,
    "Condition": "VG",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 17,
    "Condition": "G/VG",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 30,
    "Condition": "VF+",
    "Website Notes": "Spider-Woman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 52,
    "Condition": "VF",
    "Website Notes": "1st Crossfire",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Two in One",
    "Issue #": 54,
    "Condition": "VF/NM",
    "Website Notes": "Death of Deathlok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Marvel Two In One Annual",
    "Issue #": 2,
    "Condition": "CGC 9.2",
    "Website Notes": "Thanos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": "",
    "__1": ""
  },
  {
    "Title": "Master of Kung Fu",
    "Issue #": 26,
    "Condition": "NM-",
    "Website Notes": "1st Cursed Lotus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Master of Kung Fu",
    "Issue #": 29,
    "Condition": "NM-",
    "Website Notes": "1st Razor Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Master of Kung Fu",
    "Issue #": 29,
    "Condition": "VF/NM",
    "Website Notes": "1st Razor Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Master of Kung Fu",
    "Issue #": 40,
    "Condition": "CGC 6.5",
    "Website Notes": "Price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Master of Kung Fu",
    "Issue #": 46,
    "Condition": "VF",
    "Website Notes": "Gulacy Begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Master of Kung Fu Annual",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Iron Fist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Masters of the Universe",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Masters of the Universe",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Micronauts",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Micronauts",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Micronauts",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Millie the Model Annual",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Moon Knight (1980)",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Trade",
    "Cost Basis": 700,
    "": "",
    "__1": ""
  },
  {
    "Title": "Moon Knight (1980)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "2 avail",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Moon Knight (1980)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "House Flipper",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 16,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 16,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 18,
    "Condition": "VF",
    "Website Notes": "1st Mystique",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 18,
    "Condition": "F/VF",
    "Website Notes": "1st Mystique",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 37,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 20,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Ms Marvel",
    "Issue #": 23,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Muppet Babies",
    "Issue #": 15,
    "Condition": "NM",
    "Website Notes": "Star Comics",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Muppet Babies",
    "Issue #": 15,
    "Condition": "NM",
    "Website Notes": "Star Comics",
    "Personal Notes (Not on website)": "Copy 2",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nam",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Avengers",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "1st Ronin",
    "Personal Notes (Not on website)": 100,
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Avengers",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "1st Ronin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 26,
    "Condition": "NM",
    "Website Notes": "1st Legion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 87,
    "Condition": "CGC 9.8",
    "Website Notes": "1st Cable",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 87,
    "Condition": "CGC 9.8",
    "Website Notes": "1st Cable",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 87,
    "Condition": "VF",
    "Website Notes": "1st Cable",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 98,
    "Condition": "F/VF",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 98,
    "Condition": "NM/NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 98,
    "Condition": "CGC 9.2",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 98,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 230,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 98,
    "Condition": "VF+",
    "Website Notes": "CBCS 8.5 label included",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 100,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants",
    "Issue #": 100,
    "Condition": "NM",
    "Website Notes": "3rd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "New Mutants Annual",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "Psy Locke",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 115,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 165,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 10,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 12,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 12,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 13,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 13,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 14,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 15,
    "Condition": "FN",
    "Website Notes": "1st Bullseye",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nick Fury",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Nightcrawler",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1985,
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Night Nurse",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Night Nurse",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "",
    "__1": ""
  },
  {
    "Title": "Night Nurse",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Night Nurse",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Night Nurse",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 35,
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 20,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 20,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 2,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 20,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": 40,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": 40,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Not Brand Echh",
    "Issue #": 13,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 40,
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "White",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1750,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "House Flipper",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "vs Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 4,
    "Condition": "VF+",
    "Website Notes": "vs Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 24,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 4,
    "Condition": "VF+",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 14,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 16,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 17,
    "Condition": "VF/NM",
    "Website Notes": "Yellow Claw",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Nova",
    "Issue #": 25,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Omega",
    "Issue #": 2,
    "Condition": "FA",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Omega",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "Our Love Story",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Our Love Story",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "last iss Elvis",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 16,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 19,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 65,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 70,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 74,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker",
    "Issue #": 124,
    "Condition": "F/VF",
    "Website Notes": "Last iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker in Miss America",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Patsy Walker in Miss America",
    "Issue #": 67,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Phoenix the Untold Story",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1983,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys Friend",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 21,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 23,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 24,
    "Condition": "VF",
    "Website Notes": "Black Goliath",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 25,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 26,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 27,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 28,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 29,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 35,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 36,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 37,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 38,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 48,
    "Condition": "VF/NM",
    "Website Notes": "Iron Fist begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man",
    "Issue #": 48,
    "Condition": "FN+",
    "Website Notes": "Iron Fist begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 66,
    "Condition": "VF/NM",
    "Website Notes": "2nd Sabretooth",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 66,
    "Condition": "VF",
    "Website Notes": "2nd Sabretooth",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 66,
    "Condition": "VG/F",
    "Website Notes": "2nd Sabretooth",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 76,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 84,
    "Condition": "CGC 9.6",
    "Website Notes": "3rd Sabretooth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 99,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 101,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 103,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 104,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 105,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man & Iron Fist",
    "Issue #": 118,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Power Man Annual",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Punisher",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1987,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Punisher",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Jerys friend",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": 1985,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 5,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": 1986,
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Limited Series",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Punisher Annual",
    "Issue #": 2,
    "Condition": "NM+",
    "Website Notes": "Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Punisher mets Archie",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Raiders of the Lost Ark",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "6 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rawhide Kid",
    "Issue #": 22,
    "Condition": "G/VG",
    "Website Notes": "Kirby Monster c",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rawhide Kid",
    "Issue #": 34,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rawhide Kid",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rawhide Kid",
    "Issue #": 35,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rawhide Kid",
    "Issue #": 36,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Red Sonja",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "House Flipper",
    "__1": ""
  },
  {
    "Title": "Red Sonja",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Red Sonja",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Red Sonja",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Red Sonja",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Red Sonja",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Red Sonja",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Return of the Jedi",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Return of the Jedi",
    "Issue #": "1-4",
    "Condition": "NM",
    "Website Notes": "Sealed 4 Pack",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Beyond",
    "__1": ""
  },
  {
    "Title": "Robotix",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rocket Raccon",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rocket Raccon",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rocket Raccon",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rocket Raccon",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Rom",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Savage She-Hulk (1980)",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "",
    "__1": ""
  },
  {
    "Title": "Savage She-Hulk (1980)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Savage She-Hulk (1980)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Savage She-Hulk (1980)",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Savage She-Hulk (1980)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sensational She-Hulk",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "Sensational She-Hulk",
    "Issue #": 14,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sensational She-Hulk",
    "Issue #": 34,
    "Condition": "NM+",
    "Website Notes": "Byrne C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sensational She-Hulk",
    "Issue #": 39,
    "Condition": "NM/M",
    "Website Notes": "Byrne C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sensational She-Hulk",
    "Issue #": 43,
    "Condition": "NM",
    "Website Notes": "Byrne C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sensational She-Hulk",
    "Issue #": 54,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sentry",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 1,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 1,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 2,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 2,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "1st Baron Strucker",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 10,
    "Condition": "F/VF",
    "Website Notes": "1st Cap Savage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "1st Cap Savage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 13,
    "Condition": "CBCS 7.5",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 285,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 13,
    "Condition": "CGC 7.5",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 13,
    "Condition": "FN+",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 13,
    "Condition": "VG/F",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 13,
    "Condition": "G/VG",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Sgt Fury",
    "Issue #": 31,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Shanna the She-Devil",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Shanna the She-Devil",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Shanna the She-Devil",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Shanna the She-Devil",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Shield",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Shield",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "Steranko Flag Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Shield",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Steranko Flag Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 1,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 1,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 1,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 526,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 300,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Slt Color Touch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 1,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Asburn",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 4,
    "Condition": "CGC 9.0",
    "Website Notes": "Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2555,
    "": "Comiclink",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 4,
    "Condition": "CGC 6.5",
    "Website Notes": "Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 995,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 4,
    "Condition": "CGC 6.5",
    "Website Notes": "Thor",
    "Personal Notes (Not on website)": "3 avail(4 total)",
    "Cost Basis": 950,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 8,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 12,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 14,
    "Condition": "VF+",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "H Valley",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 14,
    "Condition": "VG",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "Human Torch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 16,
    "Condition": "VF",
    "Website Notes": "Mephisto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 17,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 17,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1968)",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer",
    "Issue #": 1978,
    "Condition": "NM",
    "Website Notes": "softcover 1st print",
    "Personal Notes (Not on website)": "Fireside",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer",
    "Issue #": "1-2",
    "Condition": "VF/NM",
    "Website Notes": "Limited Series",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Silver Surfer (1988)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Skull the Slayer",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Skull the Slayer",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sleepwalker",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "5 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Smurfs",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Snow White and the Seven Dwarfs",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Son of Satan",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Son of Satan",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Son of Satan",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Son of Satan",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Son of Satan",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Son of Satan",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Special Marvel Edition",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Tommy",
    "__1": ""
  },
  {
    "Title": "Special Marvel Edition",
    "Issue #": 15,
    "Condition": "VF+",
    "Website Notes": "1st Shang-Chi",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Special Marvel Edition",
    "Issue #": 15,
    "Condition": "VG/F",
    "Website Notes": "1st Shang-Chi",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "Tarantula",
    "Personal Notes (Not on website)": "3 avail 1977",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Tarantula",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 1,
    "Condition": "VG-",
    "Website Notes": "UK Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Kraven",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Lightmaster",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "Vulture",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 28,
    "Condition": "NM",
    "Website Notes": "Miller art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 28,
    "Condition": "VF/NM",
    "Website Notes": "Miller art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 64,
    "Condition": "CGC 9.8",
    "Website Notes": "1st Cloak & Dagger",
    "Personal Notes (Not on website)": "Newsstand",
    "Cost Basis": 675,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 64,
    "Condition": "CGC 9.6",
    "Website Notes": "1st Cloak & Dagger",
    "Personal Notes (Not on website)": "Direct",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spectacular Spider-Man (1977)",
    "Issue #": 90,
    "Condition": "VF/NM",
    "Website Notes": "Black Costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Man",
    "Issue #": 1,
    "Condition": "NM/M",
    "Website Notes": "Silver Direct",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Man",
    "Issue #": 1,
    "Condition": "CGC 9.4",
    "Website Notes": "Platinum",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Man",
    "Issue #": 1,
    "Condition": "NM/M",
    "Website Notes": "Regular",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Man",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Silver Polybagged",
    "Personal Notes (Not on website)": "2 aavil",
    "Cost Basis": 15,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "Spider-Man and His Amazing Friends",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Man VS The Hulk",
    "Issue #": 1979,
    "Condition": "VF/NM",
    "Website Notes": "Columbus Dispatch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "Spider-Man 2099",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "two avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Woman (1978)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Woman (1978)",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Woman (1978)",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Woman (1978)",
    "Issue #": 18,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Woman (1978)",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "Werewolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Spider-Woman (1978)",
    "Issue #": 50,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 1,
    "Condition": "CGC 9.4",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 1,
    "Condition": "CGC 9.2",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "reprint",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 2,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 43,
    "Condition": "NM",
    "Website Notes": "1st App Lando",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 43,
    "Condition": "VF",
    "Website Notes": "1st App Lando Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 68,
    "Condition": "VF",
    "Website Notes": "Boba Fett Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 94,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 95,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 98,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars",
    "Issue #": 99,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars (1982)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Movie Special",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars (1982)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Movie Special",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars (1982)",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Movie Special",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars (1982)",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Movie Special",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Star Wars Droids",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "Star Comics",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 65,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 68,
    "Condition": "P/F",
    "Website Notes": "CF Missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Owen",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 71,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 71,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 75,
    "Condition": "VG",
    "Website Notes": "Iron Man Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ogden Trade",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 77,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 77,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 77,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 78,
    "Condition": "VG/F",
    "Website Notes": "Ant Man Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 79,
    "Condition": "VG/F",
    "Website Notes": "Dr Strange Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 80,
    "Condition": "VG/F",
    "Website Notes": "Gargantus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 80,
    "Condition": "VG",
    "Website Notes": "Gargantus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 81,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 81,
    "Condition": "GD+",
    "Website Notes": "Scarecrow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 82,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 82,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 82,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 83,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 85,
    "Condition": "VG/F",
    "Website Notes": "Gargantus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 88,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 88,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 90,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 91,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 93,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 94,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 95,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 95,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 95,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 96,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 97,
    "Condition": "FN+",
    "Website Notes": "Aunt May Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 97,
    "Condition": "G/VG",
    "Website Notes": "Aunt May Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 98,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 99,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 100,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 100,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 101,
    "Condition": "CGC 7.0",
    "Website Notes": "1st Human Torch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 475,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 101,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 101,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 102,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 103,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 103,
    "Condition": "Coverless",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 104,
    "Condition": "FN-",
    "Website Notes": "1st Trapster",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 105,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 106,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 107,
    "Condition": "CGC 8.0",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "two avail",
    "Cost Basis": 650,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 107,
    "Condition": "CGC 7.0",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 107,
    "Condition": "GD",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 108,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 109,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 109,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 110,
    "Condition": "CGC 5.0",
    "Website Notes": "1st Dr Strange",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 110,
    "Condition": "CGC 4.5",
    "Website Notes": "1st Dr Strange",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2552,
    "": "Pedigree",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 112,
    "Condition": "VG/F",
    "Website Notes": "1st EEL",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 113,
    "Condition": "CGC 4.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 56,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 114,
    "Condition": "CBCS 8.0",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 650,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 114,
    "Condition": "CGC 5.5",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 114,
    "Condition": "VG/F",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 195,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 114,
    "Condition": "G/VG",
    "Website Notes": "Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 115,
    "Condition": "VG/F",
    "Website Notes": "Origin Dr Strange",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 115,
    "Condition": "FN",
    "Website Notes": "CFL O/W VF",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 115,
    "Condition": "CGC 6.5",
    "Website Notes": "Origin Dr Strange",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 545,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 118,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 121,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 121,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 123,
    "Condition": "VG",
    "Website Notes": "1st Beetle",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 125,
    "Condition": "FN-",
    "Website Notes": "Thing vs Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 126,
    "Condition": "FN",
    "Website Notes": "1st Clea",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 126,
    "Condition": "VG/F",
    "Website Notes": "1st Clea",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 127,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 128,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 130,
    "Condition": "F/VF",
    "Website Notes": "Beatles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 130,
    "Condition": "FN",
    "Website Notes": "Beatles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 134,
    "Condition": "VF",
    "Website Notes": "Watcher C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 135,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Nick Fury",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 135,
    "Condition": "VF-",
    "Website Notes": "1st Nick Fury",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Hunt Valley",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 135,
    "Condition": "FN",
    "Website Notes": "1st Nick Fury",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 135,
    "Condition": "GD+",
    "Website Notes": "1st Nick Fury",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 138,
    "Condition": "VF",
    "Website Notes": "1st Eternity",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 138,
    "Condition": "F/VF",
    "Website Notes": "1st Eternity",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Nick GE",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 139,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 140,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 148,
    "Condition": "VF+",
    "Website Notes": "Ancient One",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 148,
    "Condition": "FN",
    "Website Notes": "Ancient One",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 150,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 152,
    "Condition": "NM-",
    "Website Notes": "Kirby Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 153,
    "Condition": "VF/NM",
    "Website Notes": "Kirby Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 159,
    "Condition": "CGC 7.5",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 102,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 161,
    "Condition": "NM-",
    "Website Notes": "Yellow Claw",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 163,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 167,
    "Condition": "VF",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 167,
    "Condition": "VF+",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 167,
    "Condition": "F/VF",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 167,
    "Condition": "VG+",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 168,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 169,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Brother Voodoo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 169,
    "Condition": "VG",
    "Website Notes": "1st Brother Voodoo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 169,
    "Condition": "FN",
    "Website Notes": "1st Brother Voodoo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 178,
    "Condition": "CGC 9.4",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 178,
    "Condition": "VF/NM",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 179,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Pip",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 95,
    "": "Pedigree",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 178,
    "Condition": "F/VF",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales",
    "Issue #": 180,
    "Condition": "F/VF",
    "Website Notes": "1st Gamora",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "George",
    "__1": ""
  },
  {
    "Title": "Strange Tales Annual",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "4th Spidey",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales Annual",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": "4th Spidey",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Strange Tales Annual",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "4th Spidey",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Strawberry Shortcake",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 5,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 8,
    "Condition": "F/VF",
    "Website Notes": "vs Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 9,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "1st Set",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 10,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 10,
    "Condition": "F/VF",
    "Website Notes": "1st Barracuda",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 13,
    "Condition": "VF+",
    "Website Notes": "1st Gargantos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "Subby vs Human Torch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 17,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 18,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 19,
    "Condition": "VF",
    "Website Notes": "1st Stingray",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 22,
    "Condition": "F/VF",
    "Website Notes": "Dr Strange",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 24,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 27,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 32,
    "Condition": "F/VF",
    "Website Notes": "1st Llyra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 32,
    "Condition": "FN",
    "Website Notes": "1st Llyra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 33,
    "Condition": "VG/F",
    "Website Notes": "Namora",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 34,
    "Condition": "CGC 8.5",
    "Website Notes": "Defenders try out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 320,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "Defenders try out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 36,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 38,
    "Condition": "F/VF",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 38,
    "Condition": "NM",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 41,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 42,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 43,
    "Condition": "FN+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 43,
    "Condition": "G/VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 44,
    "Condition": "F/VF",
    "Website Notes": "VS Human Torch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 44,
    "Condition": "FN+",
    "Website Notes": "VS Human Torch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 44,
    "Condition": "FN",
    "Website Notes": "VS Human Torch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 47,
    "Condition": "VF+",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 47,
    "Condition": "VF",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 48,
    "Condition": "FN+",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 52,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 53,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 53,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 54,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 56,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 57,
    "Condition": "VF/NM",
    "Website Notes": "Everett Venus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 57,
    "Condition": "VF",
    "Website Notes": "Everett Venus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 57,
    "Condition": "F/VF",
    "Website Notes": "Everett Venus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Indy",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 57,
    "Condition": "VG/F",
    "Website Notes": "Everett Venus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 58,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 60,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 62,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 62,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 63,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 64,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 65,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 66,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 67,
    "Condition": "NM-",
    "Website Notes": "New Costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 67,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 67,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 68,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 69,
    "Condition": "VG/F",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 70,
    "Condition": "FN",
    "Website Notes": "1st Piranha",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 6,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 71,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 72,
    "Condition": "VF/NM",
    "Website Notes": "Last Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Sub-Mariner",
    "Issue #": 72,
    "Condition": "FN",
    "Website Notes": "Last Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Superhero Catalog of Games, Toys, Puzzles",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Superhero Catalog of Games, Toys, Puzzles",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Super Heroes Puzzles & Games",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Superior Spider-Man",
    "Issue #": 28,
    "Condition": "NM",
    "Website Notes": "G Goblin Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Supernatural Thrillers",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Supernatural Thrillers",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "1st Living Mummy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Supernatural Thrillers",
    "Issue #": 5,
    "Condition": "FN+",
    "Website Notes": "1st Living Mummy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Supernatural Thrillers",
    "Issue #": 8,
    "Condition": "F/VF",
    "Website Notes": "1st Elementals",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Super Villain Team Up",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Super Villain Team Up",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Super Villain Team Up",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Super Villain Team Up",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Super Villain Team Up",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Super Villain Team Up",
    "Issue #": 13,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Asgard",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 2,
    "Condition": "CGC 4.0",
    "Website Notes": "Ditko C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 10,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 11,
    "Condition": "P/F",
    "Website Notes": "CF Missing OW VG/F",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 12,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 13,
    "Condition": "FN",
    "Website Notes": "Elektro Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 15,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 15,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 17,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 17,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 18,
    "Condition": "F/G",
    "Website Notes": "Large Piece out BC",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 19,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 21,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 23,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 23,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 24,
    "Condition": "FN",
    "Website Notes": "Insect Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 25,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 25,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 26,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 55,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 27,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 28,
    "Condition": "VG/F",
    "Website Notes": "Stone Men Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 29,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 30,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 31,
    "Condition": "CGC 7.0",
    "Website Notes": "Dr Doom Prototype",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 565,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 31,
    "Condition": "VG/F",
    "Website Notes": "Dr Doom Prototype",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 32,
    "Condition": "G/VG",
    "Website Notes": "Dr Strange Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 32,
    "Condition": "GD",
    "Website Notes": "Dr Strange Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 33,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 34,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 36,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 95,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 37,
    "Condition": "VG",
    "Website Notes": "CFL OW FN+",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 37,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 38,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 39,
    "Condition": "VG+",
    "Website Notes": "1st Iron Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 7000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 39,
    "Condition": "CGC 3.0",
    "Website Notes": "1st Iron Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4000,
    "": "Steve BCC",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 39,
    "Condition": "CGC 2.5",
    "Website Notes": "1st Iron Man",
    "Personal Notes (Not on website)": "Ray",
    "Cost Basis": 9000,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 40,
    "Condition": "CGC 5.0",
    "Website Notes": "2nd Iron Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 40,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 41,
    "Condition": "GD+",
    "Website Notes": "3rd Iron Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 43,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 43,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 275,
    "": "PBA",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 43,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 44,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 45,
    "Condition": "FA",
    "Website Notes": "1st Happy/Pepper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 45,
    "Condition": "G/VG",
    "Website Notes": "1st Happy/Pepper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 45,
    "Condition": "VG",
    "Website Notes": "1st Happy/Pepper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 45,
    "Condition": "VG/F",
    "Website Notes": "1st Happy/Pepper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 46,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Bob",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 48,
    "Condition": "CGC 7.0",
    "Website Notes": "New Armor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 48,
    "Condition": "GD",
    "Website Notes": "New Armor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 49,
    "Condition": "CGC 7.0",
    "Website Notes": "Angel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 270,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 49,
    "Condition": "CGC 7.5",
    "Website Notes": "Angel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 375,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 49,
    "Condition": "F/VF",
    "Website Notes": "Angel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 49,
    "Condition": "VG/F",
    "Website Notes": "Angel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Bob/Green Valley",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 49,
    "Condition": "VG",
    "Website Notes": "Angel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 50,
    "Condition": "FN",
    "Website Notes": "1st Mandarin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 50,
    "Condition": "G/VG",
    "Website Notes": "1st Mandarin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 51,
    "Condition": "G/VG",
    "Website Notes": "1st Scarecrow",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "Bob",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 52,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Black Widow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 52,
    "Condition": "G/VG",
    "Website Notes": "1st Black Widow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 52,
    "Condition": "GD+",
    "Website Notes": "1st Black Widow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 55,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 55,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 57,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Hawkeye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 57,
    "Condition": "CGC 3.5",
    "Website Notes": "1st Hawkeye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "CConnect",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 57,
    "Condition": "GD",
    "Website Notes": "1st Hawkeye",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 57,
    "Condition": "GD+",
    "Website Notes": "1st Hawkeye",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 150,
    "": "Indy",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 58,
    "Condition": "VG+",
    "Website Notes": "Cap vs Iron Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 59,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 60,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 61,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 62,
    "Condition": "G/VG",
    "Website Notes": "origin Mandarin",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 63,
    "Condition": "F/VF",
    "Website Notes": "Origin Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 63,
    "Condition": "VG/F",
    "Website Notes": "Origin Captain America",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 64,
    "Condition": "FN+",
    "Website Notes": "3rd Hawkeye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 64,
    "Condition": "VG/F",
    "Website Notes": "3rd Hawkeye",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 65,
    "Condition": "VF-",
    "Website Notes": "1st SA Red Skull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 66,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 68,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 68,
    "Condition": "FA",
    "Website Notes": "CFO OW VG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 69,
    "Condition": "VF",
    "Website Notes": "1st Titanium Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 71,
    "Condition": "FN/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 72,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 73,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 73,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 74,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 74,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 75,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 75,
    "Condition": "FN",
    "Website Notes": "1st Bartoc",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 76,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 76,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 77,
    "Condition": "VG",
    "Website Notes": "1st Peggy Carter",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 79,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 80,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 82,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 84,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 87,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 88,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 89,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 90,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 91,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 91,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 93,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 93,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 96,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 97,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales of Suspense",
    "Issue #": 99,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 1,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 4,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 6,
    "Condition": "GD+",
    "Website Notes": "Stone Men Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 7,
    "Condition": "G/VG",
    "Website Notes": "Toad Men Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 7,
    "Condition": "F/G",
    "Website Notes": "Toad Men Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 12,
    "Condition": "VG",
    "Website Notes": "GORGILLA",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 70,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 13,
    "Condition": "VG+",
    "Website Notes": "1st GROOT",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 14,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 15,
    "Condition": "VG+",
    "Website Notes": "Electro Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 15,
    "Condition": "VG",
    "Website Notes": "Electro Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 17,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 19,
    "Condition": "VG/F",
    "Website Notes": "ROMMBU",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 21,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 100,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 22,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 22,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 23,
    "Condition": "VG/F",
    "Website Notes": "MOOMBA",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 23,
    "Condition": "VG+",
    "Website Notes": "MOOMBA",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 25,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 25,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 26,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 26,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 27,
    "Condition": "VG/F",
    "Website Notes": "1st Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2000,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 28,
    "Condition": "VG/F",
    "Website Notes": "Gorilla Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 28,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 29,
    "Condition": "FN-",
    "Website Notes": "Space Beast Invasion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Bill Thade",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 29,
    "Condition": "VG/F",
    "Website Notes": "Space Beast Invasion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 30,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 30,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 31,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 32,
    "Condition": "VG/F",
    "Website Notes": "Sandman Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 33,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 34,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 35,
    "Condition": "CBCS 6.5",
    "Website Notes": "1st Ant Man in costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 35,
    "Condition": "CGC 5.0",
    "Website Notes": "1st Ant Man in costume",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 550,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 36,
    "Condition": "CGC 7.5",
    "Website Notes": "3rd Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 36,
    "Condition": "FN-",
    "Website Notes": "3rd Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 36,
    "Condition": "VG+",
    "Website Notes": "3rd Ant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 37,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 125,
    "": "GFalls",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 38,
    "Condition": "FN-",
    "Website Notes": "1st Egghead",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 39,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 285,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 40,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 123,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 41,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 41,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 74,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 44,
    "Condition": "FN+",
    "Website Notes": "1st Wasp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 44,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Wasp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 44,
    "Condition": "CGC 3.0",
    "Website Notes": "1st Wasp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 374,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 44,
    "Condition": "VG+",
    "Website Notes": "1st Wasp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 575,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 44,
    "Condition": "VG",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 44,
    "Condition": "GD",
    "Website Notes": "Tape on spine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 44,
    "Condition": "FA",
    "Website Notes": "1st Wasp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 45,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 46,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 49,
    "Condition": "FN",
    "Website Notes": "1st Giant Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 51,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 55,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 57,
    "Condition": "VF+",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 57,
    "Condition": "CGC 5.5",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 165,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 57,
    "Condition": "VG/F",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 57,
    "Condition": "VG",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 58,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 59,
    "Condition": "FN",
    "Website Notes": "Non Story page Out O/W FN",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 60,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 62,
    "Condition": "FN+",
    "Website Notes": "1st Leader",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Rich",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 64,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 65,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 67,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 68,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 68,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 69,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 70,
    "Condition": "VF+",
    "Website Notes": "Hulk/Subby Begin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 70,
    "Condition": "FN+",
    "Website Notes": "Hulk/Subby Begin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 70,
    "Condition": "FN+",
    "Website Notes": "Hulk/Subby Begin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "green valley",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 71,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 72,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 73,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 73,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 74,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 78,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 78,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 79,
    "Condition": "CGC 8.0",
    "Website Notes": "Hercules VS Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 79,
    "Condition": "F/VF",
    "Website Notes": "Hercules VS Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 80,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 80,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 81,
    "Condition": "VF+",
    "Website Notes": "1st Boomarang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 81,
    "Condition": "FN",
    "Website Notes": "1st Boomarang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 81,
    "Condition": "VG/F",
    "Website Notes": "1st Boomarang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Green Valley",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 82,
    "Condition": "VF/NM",
    "Website Notes": "Iron Man VS Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 82,
    "Condition": "VG/F",
    "Website Notes": "Iron Man VS Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Green Valley",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 83,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 83,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 84,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 85,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 86,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 86,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 86,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 87,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 87,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 88,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 90,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 91,
    "Condition": "VG+",
    "Website Notes": "1st Abomination Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "SDCon",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 92,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 92,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 94,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 94,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 94,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 96,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 97,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 97,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 97,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 98,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 98,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 99,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 100,
    "Condition": "VF/NM",
    "Website Notes": "Hulk VS Subby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "SDCon",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 101,
    "Condition": "VF/NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 101,
    "Condition": "FN+",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tales to Astonish",
    "Issue #": 101,
    "Condition": "VG/F",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tarot",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 390,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thanos Quest",
    "Issue #": "1-2",
    "Condition": "NM",
    "Website Notes": "Book 1,2",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thanos Quest",
    "Issue #": "Book 1",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thanos Quest",
    "Issue #": "Book 2",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thing (1983)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thing (1983)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thing (1983)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 126,
    "Condition": "VG/F",
    "Website Notes": "Hercules",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 127,
    "Condition": "FN",
    "Website Notes": "Pluto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 127,
    "Condition": "VG+",
    "Website Notes": "Pluto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 128,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 128,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 128,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 130,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 131,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 131,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 131,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 132,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 133,
    "Condition": "VF/NM",
    "Website Notes": "1st Ego",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 133,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Ego",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "30th",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 133,
    "Condition": "FN-",
    "Website Notes": "1st Ego",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 133,
    "Condition": "VG/F",
    "Website Notes": "1st Ego",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 134,
    "Condition": "VG",
    "Website Notes": "1st High Evolutionary",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 135,
    "Condition": "VG+",
    "Website Notes": "Origin High Evolutionary",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 136,
    "Condition": "VG-",
    "Website Notes": "1st Sif",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 137,
    "Condition": "VG/F",
    "Website Notes": "1st Ulik",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 138,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 138,
    "Condition": "CGC 6.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 138,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 139,
    "Condition": "CGC 8.0",
    "Website Notes": "1st SIF Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 139,
    "Condition": "F/VF",
    "Website Notes": "1st SIF Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 139,
    "Condition": "FN",
    "Website Notes": "1st SIF Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 139,
    "Condition": "VG/F",
    "Website Notes": "1st SIF Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 140,
    "Condition": "FN+",
    "Website Notes": "Kang",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 144,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 146,
    "Condition": "VF",
    "Website Notes": "BC Stamp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 147,
    "Condition": "VF",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 148,
    "Condition": "VG+",
    "Website Notes": "1st Wrecker",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 149,
    "Condition": "VF+",
    "Website Notes": "Origin Black Bolt",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 149,
    "Condition": "VF",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 149,
    "Condition": "VG/F",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 151,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 152,
    "Condition": "VG/F",
    "Website Notes": "Inhumans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 153,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 153,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 153,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 154,
    "Condition": "VG/F",
    "Website Notes": "1st Mangog",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 157,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 158,
    "Condition": "VF",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 158,
    "Condition": "FN-",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 159,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 160,
    "Condition": "VF+",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 160,
    "Condition": "VG+",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 160,
    "Condition": "G/VG",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 161,
    "Condition": "VG/F",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 161,
    "Condition": "F/VF",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 161,
    "Condition": "VF+",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 162,
    "Condition": "VF+",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 162,
    "Condition": "VG/F",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 163,
    "Condition": "VF",
    "Website Notes": "Him",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 163,
    "Condition": "F/VF",
    "Website Notes": "Him",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 163,
    "Condition": "VG",
    "Website Notes": "Him",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 164,
    "Condition": "VF+",
    "Website Notes": "Him",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 164,
    "Condition": "FN",
    "Website Notes": "Him",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 165,
    "Condition": "CGC 9.0",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1900,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 165,
    "Condition": "CGC 8.0",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 165,
    "Condition": "F/VF",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 165,
    "Condition": "FN",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 165,
    "Condition": "FN-",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 175,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 166,
    "Condition": "F/VF",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 166,
    "Condition": "FN",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 166,
    "Condition": "VG",
    "Website Notes": "Warlock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 167,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 168,
    "Condition": "VF+",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 169,
    "Condition": "VF+",
    "Website Notes": "Galactus",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 170,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 171,
    "Condition": "VF+",
    "Website Notes": "Wrecker",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 171,
    "Condition": "F/VF",
    "Website Notes": "Wrecker",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Larry",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 172,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 173,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 174,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 174,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 175,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 177,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 179,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 179,
    "Condition": "VG+",
    "Website Notes": "Last Kirby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 180,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 180,
    "Condition": "VF-",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 180,
    "Condition": "FN",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 181,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 181,
    "Condition": "VF-",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 182,
    "Condition": "F/VF",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 183,
    "Condition": "NM-",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 183,
    "Condition": "FN",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 184,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 186,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 187,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 187,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 188,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 189,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 190,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 192,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 193,
    "Condition": "VF/NM",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 190,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 193,
    "Condition": "VF",
    "Website Notes": "UK Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 193,
    "Condition": "VG/F",
    "Website Notes": "S Surfer",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 195,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 208,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 216,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 221,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 223,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 225,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Firestorm",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 275,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 225,
    "Condition": "NM-",
    "Website Notes": "1st Firestorn",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 225,
    "Condition": "FN+",
    "Website Notes": "1st Firestorm",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 227,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 227,
    "Condition": "VF/NM",
    "Website Notes": "Hercules",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilliogans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 229,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilliogans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 231,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 235,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 245,
    "Condition": "VF/NM",
    "Website Notes": "Firelord",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 248,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 250,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 250,
    "Condition": "G/VG",
    "Website Notes": "price variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 337,
    "Condition": "CGC 9.8",
    "Website Notes": "Beta Ra Bill",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 650,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 337,
    "Condition": "CGC 9.6",
    "Website Notes": "Beta Ra Bill",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 337,
    "Condition": "CGC 9.2",
    "Website Notes": "Beta Ra Bill",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 110,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 337,
    "Condition": "NM",
    "Website Notes": "Canadian",
    "Personal Notes (Not on website)": "Newstand",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 337,
    "Condition": "VF/NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 337,
    "Condition": "VF/NM",
    "Website Notes": "Canadian",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Cutler",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 338,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 339,
    "Condition": "VF/NM",
    "Website Notes": "1st Storm Breaker",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 339,
    "Condition": "FN",
    "Website Notes": "1st Storm Breaker",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor",
    "Issue #": 447,
    "Condition": "NM",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor Annual",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "1994 JC Penny Reprint",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Thor (2007)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Darkness",
    "Issue #": 17,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 1,
    "Condition": "CGC 9.4",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 650,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 10,
    "Condition": "FN+",
    "Website Notes": "1st Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 10,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 10,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 10,
    "Condition": "CGC 7.0",
    "Website Notes": "1st Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1400,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 10,
    "Condition": "CGC 6.5",
    "Website Notes": "1st Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 650,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 10,
    "Condition": "CGC 6.0",
    "Website Notes": "UK Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 13,
    "Condition": "FN",
    "Website Notes": "Origin Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 13,
    "Condition": "VG",
    "Website Notes": "Origin Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 20,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 23,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 24,
    "Condition": "VF+",
    "Website Notes": "Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 25,
    "Condition": "NM-",
    "Website Notes": "1st Hannibal",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 30,
    "Condition": "VF+",
    "Website Notes": "Blade c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 47,
    "Condition": "VF+",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 68,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 70,
    "Condition": "CBCS 9.6",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Golden Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 3,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Mike",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "1st Full Jetfire",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "Transformers",
    "Issue #": 80,
    "Condition": "NM",
    "Website Notes": "Last iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "Two Gun Kid",
    "Issue #": 77,
    "Condition": "CGC 5.5",
    "Website Notes": "Black Panther proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "Two Gun Kid",
    "Issue #": 77,
    "Condition": "CGC 8.0",
    "Website Notes": "Black Panther proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "",
    "__1": ""
  },
  {
    "Title": "Two Gun Kid",
    "Issue #": 119,
    "Condition": "VF+",
    "Website Notes": "Black Panther proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Holder",
    "__1": ""
  },
  {
    "Title": "2001: A Space Odyssey",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Kirby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "House Flipper",
    "__1": ""
  },
  {
    "Title": "Ultimate Comics Spider-Man",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "2nd Miles Morales in Polybag",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Maine",
    "__1": ""
  },
  {
    "Title": "Ultimate Comics Spider-Man",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "2nd Miles Morales",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "Ultimate Fallout",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "1st Print 1st Miles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 360,
    "": "Hakes",
    "__1": ""
  },
  {
    "Title": "Vampire Tales",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "Blade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Vault of Evil",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Lehigh Valley",
    "__1": ""
  },
  {
    "Title": "Vengeance",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "1st America Chavez",
    "Personal Notes (Not on website)": "Hakes",
    "Cost Basis": 679,
    "": "",
    "__1": ""
  },
  {
    "Title": "Venom (1993)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Venom (1993)",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Venom",
    "Issue #": "Giveaway",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "Venom",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "1st Knull",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": "",
    "__1": ""
  },
  {
    "Title": "Visionaries",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Marvel/Star",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "tim",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 4,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "Dr Doom C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "Starlin sign",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Warlock",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Web of Spider-Man",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Web of Spider-Man",
    "Issue #": 29,
    "Condition": "NM",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Web of Spider-Man",
    "Issue #": 29,
    "Condition": "VF",
    "Website Notes": "Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "Web of Spider-Man",
    "Issue #": 118,
    "Condition": "VF/NM",
    "Website Notes": "Scarlet Spider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Web of Spider-Man",
    "Issue #": 119,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Weird Wonder Tales",
    "Issue #": 16,
    "Condition": "CGC 7.0",
    "Website Notes": "Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "Werewolf By Night",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "TTreasures",
    "__1": ""
  },
  {
    "Title": "Werewolf By Night",
    "Issue #": 32,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3500,
    "": "",
    "__1": ""
  },
  {
    "Title": "Werewolf By Night",
    "Issue #": 32,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1150,
    "": "Hakes",
    "__1": ""
  },
  {
    "Title": "Werewolf By Night",
    "Issue #": 32,
    "Condition": "FN+",
    "Website Notes": "1st Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Werewolf By Night",
    "Issue #": 32,
    "Condition": "FN",
    "Website Notes": "1st Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "Werewolf By Night",
    "Issue #": 33,
    "Condition": "VF",
    "Website Notes": "Moon Knight",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "HuntValley",
    "__1": ""
  },
  {
    "Title": "Werewolf By Night (2021)",
    "Issue #": 2,
    "Condition": "CGC 9.8",
    "Website Notes": "Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ray",
    "__1": ""
  },
  {
    "Title": "Western Gunfighters",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "What If",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "What If",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "What If",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Trade",
    "__1": ""
  },
  {
    "Title": "What If",
    "Issue #": 13,
    "Condition": "VF",
    "Website Notes": "Conan",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "What If",
    "Issue #": 105,
    "Condition": "CGC 9.6",
    "Website Notes": "Spider-Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Where Monsters Dwel",
    "Issue #": 16,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "DeWitt",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 2,
    "Condition": "FN/VF",
    "Website Notes": 1982,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": 1982,
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "Wolverine limited series",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": 1982,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine (1988)",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "DeWitt",
    "__1": ""
  },
  {
    "Title": "Wolverine (1988)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "Wolverine (1988)",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "Iconic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "Wolverine (1988)",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "Sabretooth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine (1988)",
    "Issue #": 75,
    "Condition": "NM",
    "Website Notes": "DF Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "Wolverine The Jungle Adventures",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "1st Apocalypse",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 5,
    "Condition": "NM-",
    "Website Notes": "1st Apocalypse",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "1st Apocalypse",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "1st Full Apocalypse",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 24,
    "Condition": "VF",
    "Website Notes": "1st Archangel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 24,
    "Condition": "NM-",
    "Website Notes": "1st Archangel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Factor",
    "Issue #": 24,
    "Condition": "NM",
    "Website Notes": "1st Archangel",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Force",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "2nd Deadpool",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Force",
    "Issue #": 2,
    "Condition": "CGC 9.8",
    "Website Notes": "2nd Deadpool",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Force",
    "Issue #": 2,
    "Condition": "CGC 9.8",
    "Website Notes": "NEWSSTAND",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 1,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 17000,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 1,
    "Condition": "CGC 3.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12000,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 1,
    "Condition": "CGC .5",
    "Website Notes": "Slt R C-1",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 2,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1150,
    "": "keith",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 2,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "1st Blob",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 4,
    "Condition": "GD+",
    "Website Notes": "1st Scarlet Witch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 4,
    "Condition": "F/G",
    "Website Notes": "1st Scarlet Witch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Kent referral",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 350,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 6,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 385,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 6,
    "Condition": "GD",
    "Website Notes": "Pin Up Page missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 7,
    "Condition": "CGC 3.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 130,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 7,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 7,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 8,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 270,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 8,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 9,
    "Condition": "G/VG",
    "Website Notes": "Avengers",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "Kent refeeral",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 9,
    "Condition": "FA",
    "Website Notes": "Avengers",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 10,
    "Condition": "VG-",
    "Website Notes": "1st Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "Kent refeeral",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 10,
    "Condition": "GD",
    "Website Notes": "1st Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "1st Stranger",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 12,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 12,
    "Condition": "CGC 6.5",
    "Website Notes": "1st Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1400,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 12,
    "Condition": "CGC 7.0",
    "Website Notes": "1st Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 785,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 12,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2100,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 12,
    "Condition": "VG",
    "Website Notes": "1st Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 13,
    "Condition": "FN",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 125,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 14,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Sentinels",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 15,
    "Condition": "FN+",
    "Website Notes": "1st Sentinels",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 14,
    "Condition": "G/VG",
    "Website Notes": "1st Sentinels",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "Annandale",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 14,
    "Condition": "P/F",
    "Website Notes": "non story page out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Jerry Hayes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 15,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "Nick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 15,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 16,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 17,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 17,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 17,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 18,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 18,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 18,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 20,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 20,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 22,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 22,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 23,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 24,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 25,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 26,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 28,
    "Condition": "F/VF",
    "Website Notes": "1st Banshee",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 29,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 29,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 29,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 30,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 32,
    "Condition": "FN-",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 32,
    "Condition": "CGC 5.5",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "comiclink",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 33,
    "Condition": "FN",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 33,
    "Condition": "VG/F",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 34,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 35,
    "Condition": "CGC 8.5",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 35,
    "Condition": "VG-",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Kent ref",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 36,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 37,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 37,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 37,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 38,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 38,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 40,
    "Condition": "FN+",
    "Website Notes": "Frankenstein C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "BCC 2024",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 40,
    "Condition": "FN",
    "Website Notes": "Frankenstein C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 44,
    "Condition": "VG/F",
    "Website Notes": "Angel",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 45,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 46,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 47,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 47,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 48,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 48,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 49,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 49,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 50,
    "Condition": "CBCS 7.5",
    "Website Notes": "Steranko Signature",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 50,
    "Condition": "FN+",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Tim",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 51,
    "Condition": "FN-",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 51,
    "Condition": "VG/F",
    "Website Notes": "Steranko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 52,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 53,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 53,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 55,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 55,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 56,
    "Condition": "FN",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 56,
    "Condition": "FN-",
    "Website Notes": "Adams Signature",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 56,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 56,
    "Condition": "VG+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 56,
    "Condition": "CGC 9.4",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 57,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 58,
    "Condition": "CGC 9.2",
    "Website Notes": "1st Havok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 375,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 58,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Havok",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Dahlgren",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 60,
    "Condition": "VF/NM",
    "Website Notes": "1st Sauron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 60,
    "Condition": "VF+",
    "Website Notes": "Staple Pull O/W NM-",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 60,
    "Condition": "F/VF",
    "Website Notes": "1st Sauron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 60,
    "Condition": "FN",
    "Website Notes": "1st Sauron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 60,
    "Condition": "FN-",
    "Website Notes": "1st Sauron",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 61,
    "Condition": "CGC 9.0",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Beyond",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 61,
    "Condition": "FN",
    "Website Notes": "Adams Sig 1st Page",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 61,
    "Condition": "VG-",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 61,
    "Condition": "FN+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 62,
    "Condition": "CGC 9.0",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Beyond",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 62,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 63,
    "Condition": "VF-",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 63,
    "Condition": "FN",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 64,
    "Condition": "VF-",
    "Website Notes": "1st Sunfire",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 64,
    "Condition": "FN",
    "Website Notes": "1st Sunfire",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 66,
    "Condition": "VF+",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 66,
    "Condition": "VG/F",
    "Website Notes": "Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 69,
    "Condition": "VG/F",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 70,
    "Condition": "VF+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Mark",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 70,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 73,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 79,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 80,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 81,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 83,
    "Condition": "VF",
    "Website Notes": "Spider-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 84,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 84,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 85,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 86,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 86,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 87,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 88,
    "Condition": "NM-",
    "Website Notes": "Frankenstein",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 108,
    "": "Todd",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 89,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 89,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 90,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 90,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 91,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 91,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 92,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 92,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 92,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 93,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 93,
    "Condition": "FN+",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 94,
    "Condition": "CGC 9.4",
    "Website Notes": "New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2100,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 94,
    "Condition": "CGC 9.0",
    "Website Notes": "New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1650,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 94,
    "Condition": "CGC 7.5",
    "Website Notes": "New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 94,
    "Condition": "CGC 6.5",
    "Website Notes": "New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 94,
    "Condition": "VG/F",
    "Website Notes": "New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 94,
    "Condition": "G/VG",
    "Website Notes": "New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "trade",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 94,
    "Condition": "GD+",
    "Website Notes": "New X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 95,
    "Condition": "CGC 9.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Matt",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 96,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 125,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 97,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 97,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "BCC 2024",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 99,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 99,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 100,
    "Condition": "VG+",
    "Website Notes": "claremont sig",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 101,
    "Condition": "CGC 9.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 101,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 101,
    "Condition": "VF",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 101,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Ron",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 102,
    "Condition": "FN+",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 102,
    "Condition": "VG/F",
    "Website Notes": "Juggernaut",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 103,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 103,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 103,
    "Condition": "F+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 105,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 105,
    "Condition": "VG/F",
    "Website Notes": "Cover Fade",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 106,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 107,
    "Condition": "F/VF",
    "Website Notes": "1st Starjammers",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "1st Starjammers",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 107,
    "Condition": "VG",
    "Website Notes": "1st Starjammers",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 108,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 108,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 109,
    "Condition": "VF+",
    "Website Notes": "Weapon X",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 111,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 111,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 112,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 112,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 114,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 116,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 117,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 117,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 118,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 118,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 118,
    "Condition": "F+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 119,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 119,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 120,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 121,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 122,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 124,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 124,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 124,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 125,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 125,
    "Condition": "VF+",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 125,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 125,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 126,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 126,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 126,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 126,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 127,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 127,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 128,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 128,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 129,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 129,
    "Condition": "CGC 9.2",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 129,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 410,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 129,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 160,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 129,
    "Condition": "FN+",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 129,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 130,
    "Condition": "F/VF",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 131,
    "Condition": "F/VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 132,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 133,
    "Condition": "VF/NM",
    "Website Notes": "UK Price Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "30th Century",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 133,
    "Condition": "VF+",
    "Website Notes": "Wolverine C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Holder",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 133,
    "Condition": "VF",
    "Website Notes": "Wolverine C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 134,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 134,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 136,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 136,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 137,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "4 avail",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 137,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 137,
    "Condition": "F/VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 138,
    "Condition": "NM-",
    "Website Notes": "Claremont Auto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 138,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 139,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 140,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 140,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 141,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 141,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 142,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 142,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 143,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 143,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 144,
    "Condition": "Vf/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 144,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 145,
    "Condition": "VF",
    "Website Notes": "Dr Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 146,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 146,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 147,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 147,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 147,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 148,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 148,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 149,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 149,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 150,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 150,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "4 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 151,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 152,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 152,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 152,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 152,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 153,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 154,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 154,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 155,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 155,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 155,
    "Condition": "FN",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 157,
    "Condition": "VG",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 158,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 158,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 159,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 159,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 159,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 160,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 160,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 160,
    "Condition": "VG/F",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 160,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 161,
    "Condition": "NM",
    "Website Notes": "Origin Magneto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 161,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 161,
    "Condition": "VF",
    "Website Notes": "Magneto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 162,
    "Condition": "NM",
    "Website Notes": "Solo Wolverine",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 162,
    "Condition": "VF",
    "Website Notes": "Solo Wolverine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 163,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 163,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 164,
    "Condition": "VF/NM",
    "Website Notes": "1st Binary",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 164,
    "Condition": "VF",
    "Website Notes": "1st Binary",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 165,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 165,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 166,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 166,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 167,
    "Condition": "VF+",
    "Website Notes": "w/Tattooz",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 167,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 168,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 168,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 168,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 169,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 169,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 170,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 171,
    "Condition": "VF/NM",
    "Website Notes": "Rogue joins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 171,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 171,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 172,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 172,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 172,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 173,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 173,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 174,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 174,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 175,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 175,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 176,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 177,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 177,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 178,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 178,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 179,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 180,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 180,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 181,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 182,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 182,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 183,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 184,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 185,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 186,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 186,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 187,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 188,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 188,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 189,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 190,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 191,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 191,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 192,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 193,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 194,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 195,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 196,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 197,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 198,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 199,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 200,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 201,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 202,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 203,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 204,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 205,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 205,
    "Condition": "NM-",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 206,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 207,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 207,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 207,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 208,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 208,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 209,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 209,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 210,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 211,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 211,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 211,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 211,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 212,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 212,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 212,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 213,
    "Condition": "NM",
    "Website Notes": "Sabretooth",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 213,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 213,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 213,
    "Condition": "VF",
    "Website Notes": "Sabretooth",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 214,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 215,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 215,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 216,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 216,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 217,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 218,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 219,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 220,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 221,
    "Condition": "NM",
    "Website Notes": "1st Mr Sinister",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 221,
    "Condition": "VG/F",
    "Website Notes": "1st Mr Sinister",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 222,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 222,
    "Condition": "VF/NM",
    "Website Notes": "Sabretooth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 223,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 224,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 225,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 225,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 226,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 227,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 228,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 229,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 230,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 230,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 231,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 232,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 233,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 233,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 234,
    "Condition": "VF/NM",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 234,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 235,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 236,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 237,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 238,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 239,
    "Condition": "NM-",
    "Website Notes": "Mr Sinister Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "SDCC",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 239,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 240,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 241,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 241,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 242,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 243,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 244,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 244,
    "Condition": "NM",
    "Website Notes": "1st Jubilee",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 244,
    "Condition": "NM-",
    "Website Notes": "1st Jubilee",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 244,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 245,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 246,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 247,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 248,
    "Condition": "NM",
    "Website Notes": "1st Jim Lee",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 248,
    "Condition": "NM",
    "Website Notes": "2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 249,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 4,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 250,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 251,
    "Condition": "VF",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 251,
    "Condition": "F/VF",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Frederick",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 252,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 253,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 256,
    "Condition": "NM",
    "Website Notes": "1st Psylocke",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 256,
    "Condition": "NM-",
    "Website Notes": "1st Psylocke",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 256,
    "Condition": "VF/NM",
    "Website Notes": "1st Psylocke",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 256,
    "Condition": "VF",
    "Website Notes": "1st Psylocke",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 258,
    "Condition": "NM-",
    "Website Notes": "Wolverine Solo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 261,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 264,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 265,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 266,
    "Condition": "NM-",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 266,
    "Condition": "CGC 9.8",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 266,
    "Condition": "CGC 9.2",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 266,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 266,
    "Condition": "VF/NM",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 266,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 101,
    "": "clink",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 266,
    "Condition": "VF",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 268,
    "Condition": "VF/NM",
    "Website Notes": "J Lee Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 268,
    "Condition": "VF/NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 268,
    "Condition": "VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 268,
    "Condition": "VF",
    "Website Notes": "J Lee Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Heroes",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 269,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 272,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 275,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 278,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 280,
    "Condition": "VF+",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 281,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 282,
    "Condition": "VF/NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 283,
    "Condition": "NM",
    "Website Notes": "1st Full Bishop",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 284,
    "Condition": "NM",
    "Website Notes": "Newstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 285,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 290,
    "Condition": "VF/NM",
    "Website Notes": "Classic Storm Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 291,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 294,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 297,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 299,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 300,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 304,
    "Condition": "NM",
    "Website Notes": "signed",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 305,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 306,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "Joe",
    "__1": ""
  },
  {
    "Title": "X-Men",
    "Issue #": 316,
    "Condition": "NM",
    "Website Notes": "signed",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Ashburn",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Jerrys friend",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "Longshot",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 12,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 14,
    "Condition": "NM",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men Annual",
    "Issue #": 14,
    "Condition": "NM-",
    "Website Notes": "1st Gambit",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men and Teen Titans",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": 1984,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men and Teen Titans",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1984,
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "Mansfield",
    "__1": ""
  },
  {
    "Title": "X-Men at the State Fair of Texas",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Dallas Times Herald",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "X-Men 2099",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Signed by Kubert & Lim w/COA",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  },
  {
    "Title": "Young Avengers (2005)",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Darnell",
    "__1": ""
  },
  {
    "Title": "Young Avengers (2005)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "",
    "__1": ""
  },
  {
    "Title": "Young Avengers (2005)",
    "Issue #": 2,
    "Condition": "NM+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": ""
  }
];
